import utilityOne from "../Assets/KPMG/investmentHub/utility/utility-1.jpg";
import utilityTwo from "../Assets/KPMG/investmentHub/utility/utility-2.png";
import utilityThree from "../Assets/KPMG/investmentHub/utility/utility-3.png";
import utilityFour from "../Assets/KPMG/investmentHub/utility/utility-4.png";
import utilityFive from "../Assets/KPMG/investmentHub/utility/utility-5.jpg";
import utilitySix from "../Assets/KPMG/investmentHub/utility/utility-6.png";
import EnergyTwo from "../Assets/KPMG/investmentHub/energy/energy-2.png";
import EnergyThree from "../Assets/KPMG/investmentHub/energy/energy-3.png";
import EnergyFour from "../Assets/KPMG/investmentHub/energy/energy-4.png";
import EnergyFive from "../Assets/KPMG/investmentHub/energy/energy-5.png";
import EnergySeven from "../Assets/KPMG/investmentHub/energy/energy-7.png";
import EnergyEight from "../Assets/KPMG/investmentHub/energy/energy-8.png";
import EnergyNine from "../Assets/KPMG/investmentHub//energy/energy-9.png";
import EnergyTen from "../Assets/KPMG/investmentHub/energy/energy-10.png";
import EnergyEleven from "../Assets/KPMG/investmentHub/energy/energy-11.png";
import EnergyOneTwo from "../Assets/KPMG/investmentHub/energy/energy-12.png";
import BuildOne from "../Assets/KPMG/investmentHub/builtEnvironment/build-1.png";
import BuildTwo from "../Assets/KPMG/investmentHub/builtEnvironment/build-2.png";
import BuildThree from "../Assets/KPMG/investmentHub/builtEnvironment/build-3.png";
import BuildFour from "../Assets/KPMG/investmentHub/builtEnvironment/build-4.png";
import BuildFive from "../Assets/KPMG/investmentHub/builtEnvironment/build-5.png";
import BuildSix from "../Assets/KPMG/investmentHub/builtEnvironment/build-6.png";
import BuildSeven from "../Assets/KPMG/investmentHub/builtEnvironment/build-7.png";
import BuildEight from "../Assets/KPMG/investmentHub/builtEnvironment/build-8.png";
import BuildNine from "../Assets/KPMG/investmentHub/builtEnvironment/build-9.png";
import BuildTen from "../Assets/KPMG/investmentHub/builtEnvironment/build-10.png";
import BuildEleven from "../Assets/KPMG/investmentHub/builtEnvironment/build-11.png";
import ConnectedBuilding from "../Assets/KPMG/investmentHub/builtEnvironment/ConnectedBuilding.jpg";
import DevelopmentWaste from "../Assets/KPMG/investmentHub/energy/DevelopmentWaste.jpg";
import GreaterCirebonMetropolitanArea from "../Assets/KPMG/investmentHub/utility/GreaterCirebonMetropolitanArea.jpg";
import JointDevelopmentofHydropower from "../Assets/KPMG/investmentHub/energy/JointDevelopmentofHydropower.jpg";
import LabuanBajoAirport from "../Assets/KPMG/investmentHub/builtEnvironment/LabuanBajoAirport.png";
import LegokNangkaRegionalWasteProcessing from "../Assets/KPMG/investmentHub/utility/LegokNangkaRegionalWasteProcessing.jpg";
import MRT11Project from "../Assets/KPMG/investmentHub/builtEnvironment/MRT11Project.jpg";
import NewDelhiRailwayStationRedevelopment from "../Assets/KPMG/investmentHub/builtEnvironment/NewDelhiRailwayStationRedevelopment.jpg";
import NewBoholInternationalAirportProject from "../Assets/KPMG/investmentHub/builtEnvironment/NewBoholInternationalAirportProject.jpg";
import OneRafflesPlaceSmartTechAdoption from "../Assets/KPMG/investmentHub/builtEnvironment/OneRafflesPlaceSmartTechAdoption.jpg";
import PhnomPenhCitySolidWasteCollection from "../Assets/KPMG/investmentHub/utility/PhnomPenhCitySolidWasteCollection.jpg";
import PiyunganWasteTreatment from "../Assets/KPMG/investmentHub/utility/PiyunganWasteTreatment.jpg";
import SemarangWastetoEnergyProject from "../Assets/KPMG/investmentHub/utility/SemarangWastetoEnergyProject.jpg";
import BohalAirport from "../Assets/KPMG/investmentHub/transportation/BohalAirport.jpg";
import BauBauPort from "../Assets/KPMG/investmentHub/transportation/BauBauPort.jpg";
import Logistics from "../Assets/KPMG/investmentHub/transportation/Logistics.jpg";
import SingAirport from "../Assets/KPMG/investmentHub/transportation/SingAirport.jpg";
import ExpressTransport from "../Assets/KPMG/investmentHub/transportation/ExpressTransport.jpg";
import BetanBusTerminal from "../Assets/KPMG/investmentHub/transportation/BetanBusTerminal.jpg";
import PuraBusTerminal from "../Assets/KPMG/investmentHub/transportation/PuraBusTerminal.jpg";
import AmbonPort from "../Assets/KPMG/investmentHub/transportation/AmbonPort.jpg";
import Subway from "../Assets/KPMG/investmentHub/transportation/Subway.jpg";
import ITTransport from "../Assets/KPMG/investmentHub/transportation/IT.jpg";
import SidrapWindFarm from "../Assets/KPMG/investmentHub/energy/SidrapWindFarm.jpg";
import SolarPowerProject from "../Assets/KPMG/investmentHub/energy/SolarPowerProject.jpg";
import ThailandAirportsExpansion from "../Assets/KPMG/investmentHub/builtEnvironment/ThailandAirportsExpansion.jpg";
import TheBantenWindFarmPowerDevelopment from "../Assets/KPMG/investmentHub/energy/TheBantenWindFarmPowerDevelopment.jpg";
import VietnamWaterSupplyInfrastructure from "../Assets/KPMG/investmentHub/utility/VietnamWaterSupplyInfrastructure.jpg";
import ClarkSolarFarmSwt from "../Assets/KPMG/investmentHub/energy/ClarkSolarFarmSwt.jpg";
import BandungMetropolitanUrbanRailway from "../Assets/KPMG/investmentHub/builtEnvironment/BandungMetropolitanUrbanRailway.jpg";
import Hospital1 from "../Assets/KPMG/investmentHub/hospital/hospital1.jpeg";
import Hospital2 from "../Assets/KPMG/investmentHub/hospital/hospital2.jpg";
import Hospital3 from "../Assets/KPMG/investmentHub/hospital/hospital3.png";
import BangkokWastewaterProject from "../Assets/KPMG/investmentHub/energy/BangkokWastewaterProject.jpg";
import BisligCityBulkWaterSupplyandSeptage from "../Assets/KPMG/investmentHub/utility/BisligCityBulkWaterSupplyandSeptage.jpg";
import BuildingRetrofittinginBugis from "../Assets/KPMG/investmentHub/utility/BuildingRetrofittinginBugis.jpg";
import ChangiEastTerminal from "../Assets/KPMG/investmentHub/builtEnvironment/ChangiEastTerminal.jpg";
import Solar1 from "../Assets/KPMG/solar1.jpg";
import Solar2 from "../Assets/KPMG/solar2.jpg";
import Solar3 from "../Assets/KPMG/solar3.jpg";
import Hydropower from "../Assets/KPMG/Hydropower.jpg";
import Naturalgas1 from "../Assets/KPMG/Naturalgas1.jpg";
import Naturalgas2 from "../Assets/KPMG/Naturalgas2.jpg";
import Other1 from "../Assets/KPMG/other1.jpg";
import Other2 from "../Assets/KPMG/other2.jpg";
import Other3 from "../Assets/KPMG/other3.jpg";
import Expressway1 from "../Assets/KPMG/expressway1.jpg";
import Expressway2 from "../Assets/KPMG/expressway2.jpg";
import Expressway3 from "../Assets/KPMG/expressway3.jpg";
import Expressway4 from "../Assets/KPMG/expressway4.jpg";
import School1 from "../Assets/KPMG/school1.jpg";
import Socialother1 from "../Assets/KPMG/socialother1.jpg";
import Socialother2 from "../Assets/KPMG/socialother2.jpg";
import Datacentres1 from "../Assets/KPMG/datacentres1.jpg";
import Datacentres2 from "../Assets/KPMG/datacentres2.jpg";
import Telecommunication1 from "../Assets/KPMG/Telecommunication1.jpg";
import Telecommunication2 from "../Assets/KPMG/Telecommunication2.jpg";
import Telecommunication3 from "../Assets/KPMG/Telecommunication3.jpg";
import Telecommunication4 from "../Assets/KPMG/Telecommunication4.jpg";
import Telecommunication5 from "../Assets/KPMG/Telecommunication5.jpg";

export const InvestmentHubDescription = [
  {
    title: "Water Supply",
    product:
      "Comprehensive water supply projects are specifically designed to meet the expanding demands of urbanization and guarantee sustainable access to clean water for our communities. These initiatives encompass essential aspects of the water supply infrastructure, including sourcing, treatment, distribution, and management.",
    investment:
      "The combination of robust government support, growing market demand, and the resilience of water supply infrastructure makes our hub an attractive destination for investment in this critical sector. Join us on this journey as we strive to meet the water needs of our communities while creating a prosperous future for all stakeholders involved.",
  },
  {
    title: "Water Treatment",
    product:
      "Water treatment projects take center stage in addressing the pressing need for clean and safe water. These initiatives are designed to overcome challenges related to water quality, pollution, and the growing demand for potable water.",
    investment:
      "Our decarb projects hub presents a compelling landscape of water treatment projects, offering diverse opportunities for investors seeking to make a significant impact while generating sustainable returns.",
  },
  {
    title: "Waste",
    product:
      "These projects focus on source separation, collection, and processing of recyclable materials, such as paper, plastic, glass, and metals. By promoting recycling, we conserve resources, reduce energy consumption, and mitigate the environmental burden of waste disposal.",
    investment:
      "With increasing waste generation and limited landfill capacity, the demand for sustainable waste management solutions is on the rise. Investing in waste projects allows investors to capitalize on this growing need and contribute to the development of environmentally sound waste management practices.",
  },
  {
    title: "Solar",
    product:
      "These initiatives employ state-of-the-art solar technologies to convert sunlight into electricity, contributing to a greener and more sustainable energy landscape.",
    investment:
      "Solar projects offer long-term revenue potential through various mechanisms, such as power purchase agreements (PPAs), feed-in tariffs, and net metering. These revenue streams provide stable and predictable returns, making solar investments attractive for investors seeking consistent cash flow.",
  },
  {
    title: "Wind",
    product:
      "Our decarb projects hub presents a vibrant landscape of wind projects, offering compelling opportunities for investors seeking sustainable and impactful ventures. By harnessing the power of the wind, these projects contribute to renewable energy generation, decarbonization, and a more sustainable future.",
    investment:
      "Wind projects contribute to energy independence by diversifying the energy mix and reducing dependence on fossil fuel imports. Furthermore, wind energy is a domestic and abundant resource, enhancing energy resilience and reducing vulnerability to geopolitical risks associated with fossil fuel dependencies.",
  },
  {
    title: "Waste to Energy",
    product:
      "These projects employ advanced technologies to convert various waste streams, such as municipal solid waste, agricultural residues, and industrial byproducts, into clean and renewable energy. These projects encompass cutting-edge technologies, efficient resource utilization, and environmental stewardship.",
    investment:
      "The global shift towards renewable energy sources presents a significant market opportunity. Waste-to-energy projects provide a dual benefit of waste management and renewable energy generation, positioning investors at the forefront of the transition to a low-carbon future.",
  },
  {
    title: "Hydropower",
    product:
      "In this brief introduction, we will explore the dynamic world of hydropower projects within our hub, highlighting their pivotal role in renewable energy generation, sustainable development, and water resource management. Hydropower projects harness the power of water to produce clean and reliable electricity, offering a range of investment prospects.",
    investment:
      "Investments in hydropower projects benefit from the technological advancements and operational experience that have been accumulated over decades, ensuring a stable investment environment.",
  },
  {
    title: "Smart Building",
    product:
      "Smart buildings integrate advanced technologies and innovative design principles to enhance energy efficiency, occupant comfort, and operational performance.",
    investment:
      "The demand for sustainable and energy-efficient buildings is on the rise. Investing in smart building projects allows investors to meet this demand and capitalize on the market shift towards greener and more technologically advanced real estate.",
  },
  {
    title: "Airports",
    product:
      "Airports are long-term infrastructure assets with stable demand, making them attractive for investors seeking steady returns. The essential nature of air travel and the continuous growth of the aviation industry provide a stable investment environment for airport projects.",
    investment:
      "decarb projects hub presents a vibrant landscape of airport projects, offering compelling opportunities for investors seeking infrastructure ventures in the aviation sector. By expanding and modernizing airport facilities, these projects contribute to enhanced transportation infrastructure, economic development, and connectivity.",
  },
  {
    title: "Railways",
    product:
      "Railway projects encompass a wide range of initiatives aimed at expanding, upgrading, and modernizing railway networks to meet the growing demands of passenger and freight transportation.",
    investment:
      "Railways are long-term infrastructure assets with stable demand, making them attractive for investors seeking steady returns. The essential nature of rail transportation and the continuous need for efficient and reliable mobility provide a stable investment environment for railway projects.",
  },
  {
    title: "Highways",
    product:
      "Highway projects encompass a wide range of initiatives aimed at expanding, upgrading, and modernizing road networks to meet the growing demands of passenger and freight transportation.",
    investment:
      "The demand for efficient transportation solutions is continuously increasing, driven by urbanization, population growth, and economic development. Investing in highway projects allows investors to meet this demand and participate in the expansion of transportation infrastructure.",
  },
];

export const InvestmentHubData = [
  {
    key: "1",
    title: "Government Network Access Project - Ilocos Norte",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Digital Infrastructure",
        subcategories: ["Data Centres"],
      },
    ],
    description: "Project Preparation and transaction advisory for a Greenfield broadband project in Philippines",
    InvestableRating: "70",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "4",
    image: ChangiEastTerminal,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "2",
    title: "Urban Renewal and Heritage Conservation Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Other"],
      },
    ],
    description: "Project Preparation and transaction advisory for urban development project in Philippines",
    InvestableRating: "75",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "2",
    image: Socialother1,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "3",
    title: "Clark International Convention Center & Sports Arena Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Other"],
      },
    ],
    description: "Project Preparation and transaction advisory for convention center project in Philippines",
    InvestableRating: "90",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "3",
    image: Socialother2,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "4",
    title: "Multi-modal Mobility Hub Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Other"],
      },
    ],
    description: "Project Preparation and transaction advisory for multi-modal hub project in Philippines",
    InvestableRating: "75",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "4",
    image: ExpressTransport,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "5",
    title: "Tri-City Ferry Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Ports"],
      },
    ],
    description: "Transaction advisory for a Greenfield ferry project in Philippines",
    InvestableRating: "70",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "2",
    image: AmbonPort,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "6",
    title: "Schools Infrastructure PPP Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Other"],
      },
    ],
    description: "Project Preparation and transaction advisory for a Greenfield schools infrastructure project in Philippines",
    InvestableRating: "85",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "3",
    image: School1,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "7",
    title: "Intramuros Transport Hub Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Other"],
      },
    ],
    description: "Project Preparation and transaction advisory for a Greenfield urban transport project in Philippines",
    InvestableRating: "85",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "4",
    image: ITTransport,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "8",
    title: "Internal Revenue Stamp Integrated System Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Other"],
      },
    ],
    description: "Project Preparation and transaction advisory for a Greenfield tax system project in Philippines",
    InvestableRating: "75",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "2",
    image: Socialother1,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "9",
    title: "Ilocos-Norte Ilocos-Sur Abra Irrigation Project (INISAIP)",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description: "Project Preparation and transaction advisory for a Greenfield irrigation project in Philippines",
    InvestableRating: "70",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "3",
    image: VietnamWaterSupplyInfrastructure,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "10",
    title: "Nuclear Medicine Research and Innovation Center O&M Project",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Other"],
      },
    ],
    description: "Transaction advisory for O&M of a healthcare project in Philippines",
    InvestableRating: "80",
    EstimatedProjectCost: "Not Disclosed",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: "4",
    image: Hospital3,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "External Sources",
    concessionPeriod: "Not Disclosed"
  },

  // Legok Nangka Regional Waste Processing and Final Processing Site
  // Jatibarang Waste Management
  // Phnom Penh City Solid Waste Collection & Transportation
  // Piyungan Waste Treatment
  // 
  {
    key: "11",
    title: "Legok Nangka Regional Waste Processing and Final Processing Site",
    Location: "Indonesia",
    City: "",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 275 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "",
    ESGRating: "3",
    image: PiyunganWasteTreatment,
    map: "Indonesia",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "",
    concessionPeriod: "",
  },
  {
    key: "12",
    title: "Jatibarang Waste Management",
    Location: "Indonesia",
    City: "",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 224 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "",
    ESGRating: "4",
    image: BisligCityBulkWaterSupplyandSeptage,
    map: "Indonesia",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "",
    concessionPeriod: "",
  },
  {
    key: "13",
    title: "Phnom Penh City Solid Waste Collection & Transportation",
    Location: "Cambodia",
    City: "Phnom Penh",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 46 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "",
    ESGRating: "2",
    image: PiyunganWasteTreatment,
    map: "Cambodia, Phnom Penh",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "",
    concessionPeriod: "",
  },
  {
    key: "14",
    title: "Piyungan Waste Treatment",
    Location: "Indonesia",
    City: "",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 177 Million",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink:
      "",
    ESGRating: "2",
    image: utilitySix,
    map: "Indonesia",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "",
    concessionPeriod: "",
  },
  {
    key: "23",
    title: "25-MW Clark Solar Farm Swt",
    Location: "Philippine",
    City: "New Clark City",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"],
      },
    ],
    description:
      "A 25-megawatt solar farm project in New Clark City, 87km north of of the capital, is planned to be built via a public-private partnership (PPP) deal, the Philippines’ Bases Conversion and Development Authority (BCDA) announced Wednesday.",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 18 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://gulfnews.com/business/energy/philippines-25-mw-clark-solar-farm-set-1.1678269937860",
    ESGRating: "3",
    image: ClarkSolarFarmSwt,
    map: "Philippine,New%20Clark%20City",
    contactName: "",
    contactEmail: "info@ppp.gov.ph",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Gulf News",
    concessionPeriod: "25",
  },
  {
    key: "24",
    title: "Joint Development of Hydropower Projects in Nepal (1185 MW)",
    Location: "Nepal",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Hydropower"],
      },
    ],
    description:
      "The large-scale solar project will be located on a 37-hectare parcel of land in the northern portion of the New Clark City.",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 1700 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "",
    ESGRating: "3",
    image: EnergyOneTwo,
    map: "Nepal",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "",
    concessionPeriod: "",
  },
  {
    key: "28",
    title: "Development of Singkawang Airport",
    Location: "Indonesia",
    City: "Singkawang, West Kalimantan Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Airports"],
      },
    ],
    description:
      "Based on the Decree of the Minister of Transportation No. KP 1024 of 2018, Singkawang Airport will be located in Panglimang Village, South Singkawang District. Singkawang Airport PPP Project is considered to be located in a potential area considering the plan of Relocation of the Capital City of Indonesia from Jakarta to East Kalimantan, which will make a positive contribution to the surrounding areas, including West Kalimantan Province and Singkawang City. At the moment, the Government of Singkawang City has completed the land acquisition activity covering an area of 151.45 ha to accelerate the development of the airport which is planned to be developed in 3 phases.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 116.36 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "5",
    image: SingAirport,
    map: "Indonesia, West Kalimantan",
    contactName: "Arief Mustofa",
    contactEmail: "aspar.amri@ymail.com",
    financialFeasibility: {
      irr: "15.36%",
      npv: "15.38",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "33",
  },
  // {
  //   key: "30",
  //   title: "Development of New Ambon Port",
  //   Location: "Indonesia",
  //   City: "Central Maluku District, Maluku Province",
  //   categories: [
  //     {
  //       name: "Transportation",
  //       subcategories: ["Ports"],
  //     },
  //   ],
  //   description:
  //     "The New Ambon Port was designed to integrate the center for the growth of the fish processing industry with the cargo consolidation from Eastern Indonesia. This integrated port development concept includes international and domestic container terminals, Roro terminals, fishing ports (fish auction and processing sites), industrial and logistics areas, LNG terminals, and power plants.",
  //   InvestableRating: "50",
  //   EstimatedProjectCost: "USD 90.59 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Planning",
  //   SupportLink:
  //     "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
  //   ESGRating: "4",
  //   image: AmbonPort,
  //   map: "Indonesia, Maluku",
  //   contactName: "Aries Wibowo",
  //   contactEmail: "kpbupelabuhan@gmail.com",
  //   financialFeasibility: {
  //     irr: "",
  //     npv: "",
  //   },
  //   source: "PPP Infrastructure projects plan in Indonesia 2022",
  //   concessionPeriod: "",
  // },
  // {
  //   key: "24",
  //   title: "Changi East Terminal and Supporting Infrastructure",
  //   Location: "Singapore",
  //   City: "Singapore",
  //   categories: [
  //     {
  //       name: "Transportation",
  //       subcategories: ["Airports"],
  //     },
  //   ],
  //   description:
  //     "Changi international airport’s new passenger Terminal 5 (T5) in Singapore will have an annual passenger capacity of 50 million.",
  //   InvestableRating: "60",
  //   EstimatedProjectCost: "USD 10,000 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Procurement",
  //   SupportLink:
  //     "https://www.airport-technology.com/projects/terminal-5-changi-international-airport/",
  //   ESGRating: "5",
  //   image: ChangiEastTerminal,
  //   map: "Singapore",
  //   contactName: "",
  //   contactEmail: "",
  //   financialFeasibility: {
  //     irr: "",
  //     npv: "",
  //   },
  //   source: "",
  //   concessionPeriod: "",
  // },
  // {
  //   key: "25",
  //   title: "Thailand Airports Expansion",
  //   Location: "Thailand",
  //   City: "Bangkok",
  //   categories: [
  //     {
  //       name: "Transportation",
  //       subcategories: ["Airports"],
  //     },
  //   ],
  //   description:
  //     "The Airports of Thailand Public Company Limited (AOT) plans to invest 100 billion THB (2.8 billion USD) in the expansion of its six international airports in Thailand over the next five years.",
  //   InvestableRating: "40",
  //   EstimatedProjectCost: "USD 2,800 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Procurement",
  //   SupportLink:
  //     "https://en.vietnamplus.vn/thailand-to-invest-nearly-3-billion-usd-in-expanding-international-airports/255667.vnp#:~:text=The%20Airports%20of%20Thailand%20Public,over%20the%20next%20five%20years.",
  //   ESGRating: "3",
  //   image: ThailandAirportsExpansion,
  //   map: "Thailand, Bangkok",
  //   contactName: "",
  //   contactEmail: "",
  //   financialFeasibility: {
  //     irr: "",
  //     npv: "",
  //   },
  //   source: "",
  //   concessionPeriod: "",
  // },
  // {
  //   key: "26",
  //   title: "MRT-11 Project",
  //   Location: "Philippine",
  //   City: "national",
  //   categories: [
  //     {
  //       name: "Transportation",
  //       subcategories: ["Railways"],
  //     },
  //   ],
  //   description:
  //     "The project involves the construction of an approximately 18-km Metro Railway Transit System (MRTS) of elevated structure starting from EDSA, Balintawak in Quezon City traversing along Quirino Highway, Novaliches, and Zabarte Road in North Caloocan City up to Barangay Gaya-gaya in San Jose del Monte, Bulacan. A passenger transfer facility shall be provided proximate to the EDSA-Balintawak station of LRT Line 1 and the MRT 11 Balintawak station.",
  //   InvestableRating: "70",
  //   EstimatedProjectCost: "USD 1,471 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Procurement",
  //   SupportLink: "https://ppp.gov.ph/ppp_projects/mrt-11-project/",
  //   ESGRating: "5",
  //   image: MRT11Project,
  //   map: "Philippines",
  //   contactName: "",
  //   contactEmail: " info@ppp.gov.ph",
  //   financialFeasibility: {
  //     irr: "",
  //     npv: "",
  //   },
  //   source: "",
  //   concessionPeriod: "",
  // },
  // {
  //   key: "27",
  //   title: "Bandung Metropolitan Urban Railway Project",
  //   Location: "Indonesia",
  //   City: "West Java",
  //   categories: [
  //     {
  //       name: "Transportation",
  //       subcategories: ["Railways"],
  //     },
  //   ],
  //   description:
  //     "The project involves the construction of an approximately 18-km Metro Railway Transit System (MRTS) of elevated structure starting from EDSA, Balintawak in Quezon City traversing along Quirino Highway, Novaliches, and Zabarte Road in North Caloocan City up to Barangay Gaya-gaya in San Jose del Monte, Bulacan. A passenger transfer facility shall be provided proximate to the EDSA-Balintawak station of LRT Line 1 and the MRT 11 Balintawak station.",
  //   InvestableRating: "70",
  //   EstimatedProjectCost: "USD 810.38 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Procurement",
  //   SupportLink:
  //     "https://investinindonesia.uk/wp-content/uploads/2022/08/PPP-Bandung-Metropolitan-Urban-Railway.pdf",
  //   ESGRating: "5",
  //   image: BandungMetropolitanUrbanRailway,
  //   map: "Indonesia, West Java",
  //   contactName: "Ir. A. Koswara, MP",
  //   contactEmail: "dishub@jabarprov.go.id",
  //   financialFeasibility: {
  //     irr: "13.30%",
  //     npv: "340.35",
  //   },
  //   source: "",
  //   concessionPeriod: "34",
  // },
 
  
  {
    key: "31",
    title: "Betan Subing Type A Bus Terminal Development",
    Location: "Indonesia",
    City: "Betan Subing, Lampung Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Bus"],
      },
    ],
    description:
      "To improve the terminal infrastructure quality to provide better transportation service, the Minister of Transportation has planned to develop a Type A Bus Terminal at Betan Subing, Lampung Province. Betan Subing terminal is located adjacent to the Trans Sumatra toll road. There is a Terbanggi Besar toll gate for the road to Betan Subing terminal and the national road if it is reached from arterial roads or non-toll roads.",
    InvestableRating: "60",
    EstimatedProjectCost: "USD 16.72 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "5",
    image: BetanBusTerminal,
    map: "Indonesia, Betan",
    contactName: "Susanty Pertiwi",
    contactEmail: "s.pertiwi74@gmail.com",
    financialFeasibility: {
      irr: "13.9%",
      npv: "8.66",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "32",
    title: "Purabaya Type A Bus Terminal Development",
    Location: "Indonesia",
    City: "Sidoarjo, East Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Bus"],
      },
    ],
    description:
      "To improve the quality of the terminal to provide better transportation service, the Ministry of the Transportation is planning to develop Purabaya Type A Bus Terminal at Sidoarjo, East Java Province through Public-Private Partnership Scheme. The development of this terminal drives an increase in transportation access and economic development through a mixed-use terminal scheme",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 24.39 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: PuraBusTerminal,
    map: "Indonesia, East Java",
    contactName: "Susanty Pertiwi",
    contactEmail: "s.pertiwi74@gmail.com",
    financialFeasibility: {
      irr: "18.8%",
      npv: "12.43",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "33",
    title: "Kalimantan Type A Bus Terminal Development",
    Location: "Indonesia",
    City: "West Kalimantan Province, South Kalimantan Province, East Kalimantan Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Bus"],
      },
    ],
    description:
      "To accelerate the development and to provide better transportation service, the Ministry of Transportation is planning to upgrade its terminals in Kalimantan Island through PublicPrivate Partnership Scheme. Initially, there are 3 bus terminal sites in Kalimantan that are suitable for PPP: Samarinda Bus Terminal – located near Mahakam River, the terminal is planned to attract more passenger through its Skybridge. This skybridge will connect the terminal and river transport-pier, which will boost riverside tourism. Gambut Barakat Bus Terminal – A mixed-use concept bus terminal designed as a hub for people activities. Some of the captive markets of this terminal are Higher education campus and commerce which already rent some of the terminal space. It’s also integrated with Trisakti Logistic Port. Singkawang Bus Terminal – A greenfield terminal with a mixed-use concept (Tourism and Grocery center) focusing to serve bustling tourists during Chinese New Year festival and as Inter-country commercial point between Malaysia and Indonesia.",
    InvestableRating: "60",
    EstimatedProjectCost: "USD 32.26 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: BetanBusTerminal,
    map: "Indonesia, West Kalimantan",
    contactName: "Susanty Pertiwi",
    contactEmail: "s.pertiwi74@gmail.com",
    financialFeasibility: {
      irr: "10.68%",
      npv: "6.4",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "34",
    title: "Bandung Metropolitan Urban Railway",
    Location: "Indonesia",
    City: "Greater Bandung, West Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Railways"],
      },
    ],
    description:
      "In 2019 around 12.3 million trips per day were made in Greater Bandung, only 12% of them were made by public transport. It is estimated that about one third (36%) of the road network will be saturated by 2023 and this will increase to about two thirds (70.5%) by 2030. The proposed mass transit project will therefore make better use of limited urban space by moving people faster and more reliably.",
    InvestableRating: "40",
    EstimatedProjectCost: "USD 810 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: BandungMetropolitanUrbanRailway,
    map: "Indonesia, West Java",
    contactName: "Ir. A. Koswara, MP",
    contactEmail: "dishub@jabarprov.go.id",
    financialFeasibility: {
      irr: "13.3%",
      npv: "340.35",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "34",
  },
  {
    key: "35",
    title:
      "Semarang Harbour Toll Road Integrated with Water Resource Control System",
    Location: "Indonesia",
    City: "Central Java",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct ± 20.16 km of Semarang Harbour toll road which connects the Semarang-Batang Toll Road and Semarang-Demak Toll Road to complete the Ring Road around the City of Semarang. This toll road will be integrated with the sea dike and retention pond in the city of Semarang. The return of investment of the sea dike comes from the development of the reclamation area given to the winner of the auction while the retention pond will be financed by the government of Semarang city and other financing schemes.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 1,393  Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "5",
    image: ITTransport,
    map: "Indonesia, Central Java",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "50",
  },
  {
    key: "36",
    title: "Malang – Kepanjen Toll Road",
    Location: "Indonesia",
    City: "East Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct a ±29.787 km toll road of Malang-Kepanjen which is expected to overcome traffic problems and boost economic and regional growth. This toll road is equipped with 2 junctions and 4 interchanges.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 693 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: BandungMetropolitanUrbanRailway,
    map: "Indonesia, East Java",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "45",
  },
  {
    key: "37",
    title: "Kediri-Tulungagung Toll Road",
    Location: "Indonesia",
    City: "East Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct a ±44.51 km toll road of Kediri-Tulungagung which is expected to encourage economic and regional growth for the south part of East Java and also become an access road to Kediri Airport. This toll road plan is equipped with 2 junctions and 3 interchanges.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 714 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: ExpressTransport,
    map: "Indonesia, East Java",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "50",
  },
  {
    key: "40",
    title: "Makassar-Maros-Sungguminasa-Takalar Toll Road",
    Location: "Indonesia",
    City: "South Sulawesi Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct approximately 48 Km of Mamminasata toll road. This Toll Road will connect Maros Sub-district and Takalar Sub-district without passing through Makassar City and is expected to shorten the logistics path between the two regions. Mamminasata Toll Road is planned to have 4 trumpet-type interchanges.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 689 Million",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "5",
    image: ExpressTransport,
    map: "Indonesia, South Sulawesi Province",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "50",
  },
  {
    key: "41",
    title:
      "Operational and Maintenance (OM) Surabaya-Madura (Suramadu) Bridge Bundling with Bandara Juanda-Tanjung Perak Toll Road (Surabaya Eastern Ring Road/SERR)",
    Location: "Indonesia",
    City: "East Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "Suramadu Bridge which connects Surabaya City and Madura Island (Bangkalan), is the longest cable-stayed bridge in Indonesia. It stretches along 5,438 meters with 100 years of service life and requires operation and maintenance. There is potential to finance the operation and maintenance of Suramadu Bridge by bundling it with Bandara Juanda - Tanjung Perak Toll Road (SERR)",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 688 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: ExpressTransport,
    map: "Indonesia, East Java",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "50",
  },
  {
    key: "42",
    title: "Ngawi-Bojonegoro-Babat Toll Road",
    Location: "Indonesia",
    City: "East Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct a 106,409 km toll road of Ngawi-Bojonegoro-Babat which has been listed in Presidential Regulation Number 80/2019. This toll road is equipped with 2 junctions and 3 interchanges, and it will pass through the Gas Unitization Field Development of Jambaran-Tiung Biru in Bojonegoro Regency and Blok Cepu Area",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 1,925 Million",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: ExpressTransport,
    map: "Indonesia, East Java",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "50",
  },
  {
    key: "43",
    title: "Demak-Tuban Toll Road",
    Location: "Indonesia",
    City: "Central Java Province and East Java Province",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct a 180.85 km toll road from Demak-Tuban which is expected to support Presidential Regulation Number 79/2019, Presidential Regulation Number 80/2019, and encourage economic and regional growth. This toll road is equipped with 7 interchanges and 1 junction.",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 3,162 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: ExpressTransport,
    map: "Indonesia, Central Java",
    contactName: "Denny Firmansyah",
    contactEmail: "bpjt@pu.go.id",
    financialFeasibility: {
      irr: "11.56%",
      npv: "91.84",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "35",
  },
  {
    key: "44",
    title: "Cilacap-Yogyakarta Toll Road",
    Location: "Indonesia",
    City: "Central Java",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is to construct a 121.75 km toll road of Cilacap-Yogyakarta and to complete the toll road network in the South of Central Java Province which is expected to stimulate growth in the central-south region with its various potentials. The starting point of this toll road is at the endpoint of Gedebage-Tasikmalaya-Cilacap Toll Road and is equipped with 6 interchanges and 1 on/off ramp at the end section which is connected to the NYIA-Yogyakarta-Solo Toll Road.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 2,174 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: ExpressTransport,
    map: "Indonesia, Central Java",
    contactName: "Ira Ariani Chaerunisa",
    contactEmail: "direktorat.ppijj@pu.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "50",
  },
  {
    key: "45",
    title: "Development of Merangin Dam",
    Location: "Indonesia",
    City: "Jambi",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "The Merangin Dam project is built as a multifunction dam that will accommodate irrigation for 12.000 ha, flood control of about 583.5 m3 /sec in the densely populated lower part of the Merangin basin, the raw water supply of about 2 m3 /s, and might also be electricity needs up to 90-107.5 MW.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 262 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: utilityOne,
    map: "Indonesia, Jambi",
    contactName: "Arvi Argyantoro",
    contactEmail: "dit_ppisda@pu.go.id",
    financialFeasibility: {
      irr: "10.00%",
      npv: "12.79",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "46",
    title: "Development of Bodri Dam in Kendal Regency",
    Location: "Indonesia",
    City: "Kendal, Central Java Province",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "As a city located in a coastal area and in the estuary of 12 rivers that pass through its territory, the Bodri River has the potential to be used as a dam for irrigation, raw water supply, the potential for electric power and flood control in overcoming floods that occurred in Kendal district. This project's scope is to design, build, finance, and maintain the dam and its supporting infrastructure and transfer",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 121 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: LegokNangkaRegionalWasteProcessing,
    map: "Indonesia, Central Java",
    contactName: "Arvi Argyantoro",
    contactEmail: "dit_ppisda@pu.go.id",
    financialFeasibility: {
      irr: "9.46%",
      npv: "35.33",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "47",
    title: "Development of Kamijoro Regional Water Supply System",
    Location: "Indonesia",
    City: "Kulon Progo and Bantul, Special Region of Yogyakarta",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "Kamijoro Regional Water Supply system is a provincial project in the Special Region of Yogyakarta, that aimed to supply the drinking water (Air Minum Curah) to the regencies of Bantul and Kulon Progo. The project was initiated due to limited water resources for local people, while also supporting the current development of New Yogyakarta International Airport and industrial areas within both regencies. The project utilizes bulk water from the Progo River through Kamijoro Dam, which has been planned to supply 475 lps drinking water, consisting of 189 lps to Bantul Regency and 286 lps to Kulon Progo Regency. The involvement of private sectors through PPP is expected to overcome project cost constraints while improving the quality and continuity of water supply services. The scope of the Special Purpose Company (“SPC”) is developing Water Treatment Plant (“WTP”) and main distribution pipeline, as well as operating the system during the concession period. The further scope will be studied and finalized in FBC Final Report.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 24 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: BisligCityBulkWaterSupplyandSeptage,
    map: "Indonesia, Yogyakarta",
    contactName: "Arvi Argyantoro",
    contactEmail: "dit_ppisda@pu.go.id",
    financialFeasibility: {
      irr: "15.00%",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "25",
  },
  {
    key: "48",
    title: "Development of Jatigede Regional Water Supply System",
    Location: "Indonesia",
    City: "West Java",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "The Jatigede Water Supply Project aims to increase the water supply capacity to meet the demand in West Java. The off-takers of the drinking water are five regionals: Sumedang Regency, Majalengka Regency, Cirebon Regency, Indramayu Regency, and the City of Cirebon. The drinking water capacity is 2,000 lps at Kadipaten, Majalengka Regency.",
    InvestableRating: "60",
    EstimatedProjectCost: "USD 144 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: VietnamWaterSupplyInfrastructure,
    map: "Indonesia, West Java",
    contactName: "Agus Priono, M.Ec",
    contactEmail: "dppm@jogjaprov.go.id, prionoagus67@gmail.com",
    financialFeasibility: {
      irr: "15.00%",
      npv: "4.532",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "49",
    title: "Wosusokas Regional Water Supply System Phase II",
    Location: "Indonesia",
    City: "Central Java",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "Wosusokas Regional Water Supply System provides clean water for the population in Wonogiri Regency, Karanganyar Regency, Sukoharjo Regency, and Surakarta City. The need for clean water will increase due to the growing population in this area. The project will be done in two phases, with phase II to be constructed using the PPP scheme.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 52 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: utilityFour,
    map: "Indonesia, Central Java",
    contactName: "Anom Guritno, ST, M.Ling",
    contactEmail: "anomguritno@yahoo.com",
    financialFeasibility: {
      irr: "14.20%",
      npv: "28.37",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "50",
    title: "Pantura Regional Water Supply System",
    Location: "Indonesia",
    City: "East Java Province",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "Pantura Regional Water Supply is planned to serve Bojonegoro Regency, Tuban Regency, and Lamongan Regency. The Pantura Regional Water Supply is one of the projects listed in the Presidential Decree 80 of 2019. It is planned that the water source will come from the Bengawan Solo River.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 98 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    map: "Indonesia, East Java",
    image: utilitySix,
    contactName: "M. Falahul A. A",
    contactEmail: "falahalharamaini@gmail.com",
    financialFeasibility: {
      irr: "12.36%",
      npv: "6.96",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "25",
  },
  {
    key: "51",
    title: "Development of Sinumbra Water Supply System",
    Location: "Indonesia",
    City: "West Java",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "The Greater Bandung Metropolitan Regional Water Supply Project West Region-1 Sinumbra (Sinumbra Water Supply) is a Drinking Water Supply System that will supply bulk water to western parts of the Bandung Metropolitan area with a capacity of 1,200 Liters/second to serve 120,000 house connections. The Sinumbra Regional Water Supply System supplies water from 3 springs in Sinumbra Plantation at 1,300-1,428 m asl to Metropolitan Bandung Area (approx. 700 m asl).",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 51 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: utilityThree,
    map: "Indonesia, West Java",
    contactName: "Drs. Wahyu Mijaya SH. M.Si",
    contactEmail: "airminum.disperkim@jabarprov.go.id",
    financialFeasibility: {
      irr: "12.56%",
      npv: "22.3",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "52",
    title: "Development of Waste to Energy Facility In South Tangerang",
    Location: "Indonesia",
    City: "South Tangerang, Banten Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Waste to Energy"],
      },
    ],
    description:
      "Waste management of 800 tonnes per day is located in South Tangerang, Banten. Electricity output and Purchased Agreement with PLN will be determined during the finalization of the Final Business Case. The scope of this project is to design, build, finance, operate, and maintain the WTE plant and supporting infrastructure.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 122 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "5",
    image: utilityFive,
    map: "Indonesia, Banten Province",
    // map: "https://maps.google.com/maps?q=Indonesia,South%20Tangerang,%20Banten%20Province&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed",
    contactName: "Rastra Yudhatama,S.STP",
    contactEmail: "tamayudha88@gmail.com",
    financialFeasibility: {
      irr: "10.00%",
      npv: "36.84",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "53",
    title: "Piyungan Waste Treatment",
    Location: "Indonesia",
    City: "Special Region of Yogyakarta",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "The capacity of waste landfill (TPA) has been exceeded while there is an increase in the volume of waste that enters Piyungan Landfill, so appropriate technology and professional operation management are necessary. Piyungan Landfill receives around 650 - 700 tonnes per day of waste from Yogyakarta City, Sleman Regency, and Bantul Regency.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 123 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: PiyunganWasteTreatment,
    map: "Indonesia, Yogyakarta",
    // map: "https://maps.google.com/maps?q=Indonesia,Special%20Region%20of%20Yogyakarta&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed",
    contactName: "Agus Priono, M..Ec",
    contactEmail: "dppm@jogjaprov.go.id/ prionoagus67@gmail.com",
    financialFeasibility: {
      irr: "30.50%",
      npv: "177",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "20",
  },
  {
    key: "54",
    title:
      "Integrated Hazardous and Specific Waste Management Facility in Sumatera",
    Location: "Indonesia",
    City: "North Sumatera Province",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "This project aims to develop the Integrated Hazardous and Specific Waste Management Facility in Sumatera Area with PPP scheme. The project scheme implemented will be buildoperate-transfer. The proposed location for this project will be at Simalungun Regency, North Sumatera (indicative option).",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 69 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: utilitySix,
    map: "Indonesia, Medan, North Sumatera Province",
    contactName: "Sri Murwani Nurfadilastuti",
    contactEmail: "progrev.pslb3@gmail.com",
    financialFeasibility: {
      irr: "15.70%",
      npv: "32.91",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "10",
  },
  {
    key: "55",
    title: "Natural Gas Distribution Network for Medan City Households",
    Location: "Indonesia",
    City: "Medan, North Sumatera Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection in 21 sub-districts in Medan city. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 206 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: EnergyFive,
    map: "Indonesia, Medan, North Sumatera Province",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "56",
    title:
      "Natural Gas Distribution Network for Bandar Lampung City Households",
    Location: "Indonesia",
    City: "Bandar Lampung, Lampung Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 329,395 home connections in Bandar Lampung City. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 184 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: EnergyFive,
    map: "Indonesia, Bandar Lampung",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "57",
    title: "Natural Gas Distribution Network for Batam City Households",
    Location: "Indonesia",
    City: "Batam, Riau Island Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 307,749 home connections in Batam City. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 165 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: EnergyThree,
    map: "Indonesia, Batam",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "58",
    title: "Natural Gas Distribution Network for Palembang City Households",
    Location: "Indonesia",
    City: "Palembang, South Sumatera Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 354,441 home connections in Palembang City. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 223 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4.5",
    image: EnergyFour,
    map: "Indonesia, Palembang",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "59",
    title: "Natural Gas Distribution Network for Pasuruan City Households",
    Location: "Indonesia",
    City: "Pasuruan, East Java Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 36,213 home connections in Pasuruan City. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 22 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4.5",
    image: EnergyOneTwo,
    map: "Indonesia, Pasuruan",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "60",
    title: "Natural Gas Distribution Network for Mojokerto City Households",
    Location: "Indonesia",
    City: "Mojokerto, East Java Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 29,575 home connections in Mojokerto City. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 16 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4.5",
    image: EnergyEleven,
    map: "Indonesia, Mojokerto",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "61",
    title: "Natural Gas Distribution Network for Cirebon Regency Households",
    Location: "Indonesia",
    City: "Cirebon Regency, Central Java Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 359,852 home connections in Cirebon Regency. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 213 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "4",
    image: EnergyEight,
    map: "Indonesia, Central%20Java%20Province",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "62",
    title: "Natural Gas Distribution Network for Jombang Regency Households",
    Location: "Indonesia",
    City: "Jombang Regency, East Java Province",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"],
      },
    ],
    description:
      "Construction and operation network distribution of household gases from the tie-in to stove connection for 351,217 home connections in Jombang Regency. There are 2 (two) business activities related to piped gas, as a transporter and as a gas distributor through pipelines.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 221 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://perpustakaan.bappenas.go.id/e-library/file_upload/koleksi/migrasi-data-publikasi/file/Policy_Paper/PPP%20Book%202022.pdf",
    ESGRating: "3",
    image: EnergyTen,
    map: "Indonesia, Jombang%20Regency,%20East%20Java%20Province",
    contactName: "Retna Aribawani",
    contactEmail: "retna.aribawani@esdm.go.id",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Infrastructure projects plan in Indonesia 2022",
    concessionPeriod: "30",
  },
  {
    key: "63",
    title:
      "Road Transport Information Technology (IT) Infrastructure Project (Phase II)",
    Location: "Philippine",
    City: "national",
    categories: [
      {
        name: "Transportation",
        subcategories: ["IT"],
      },
    ],
    description: `The project involves the upgrade of existing IT infrastructure of the Land Transportation and Franchising Regulatory Board (LTFRB), including: (a) computerization of its manual processes; (b) development of an online database of franchise information; (c) data migration; and (d) procurement, installation, operations and management of IT hardware equipment, software and network development.

    The project aims to deliver a transparent and efficient franchising system through streamlining of LTFRB’s current processes and automation. It is expected to clean up existing data; enhance data collection, processing and integration within LTFRB and its related agencies; decrease processing time; promote transparency and ease of use; and improve access to public information and channels for feedback.`,
    InvestableRating: "70",
    EstimatedProjectCost: "USD 7 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.gov.ph/ppp_projects/road-transport-it-infrastructure-project-phase-ii/",
    ESGRating: "4",
    image: ITTransport,
    map: "philippines",
    contactName: "MS. AIRENE M. ROBINSON",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Republic of the Philippines Public-Private Partnership Center",
    concessionPeriod: "",
  },
  {
    key: "64",
    title:
      "Metro Manila Subway Project (MMSP) Operations and Maintenance (O&M) PPP Project",
    Location: "Philippine",
    City: "national",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Subway"],
      },
    ],
    description:
      "The Project involves the operations and maintenance of the Metro Manila Subway Project (“MMSP”) System which include the following components: (a) Depots, including Maintenance Plant and facilities; (b) Stations; (c) Wayside infrastructure; (d) Operation Control Centre (OCC) and Back Office; (e) Trains and Rolling Stock; (f) Track; (g) Traction Power Supply system; (h) Signaling command and control systems; (i) Telecommunication systems and networks; (j) Automatic fare collection systems; (k) Station Electrical & Mechanical (E&M); (l) Passenger information systems; (m) Civil infrastructure.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 47 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.gov.ph/ppp_projects/metro-manila-subway-project-mmsp-operations-and-maintenance-om-ppp-project/",
    ESGRating: "5",
    image: Subway,
    map: "philippines",

    contactName: "",
    contactEmail: "info@ppp.gov.ph",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Republic of the Philippines Public-Private Partnership Center",
    concessionPeriod: "",
  },
  {
    key: "65",
    title: "Quezon City Integrated Solid Waste Management Facility Project",
    Location: "Philippine",
    City: "Quezon",
    categories: [
      {
        name: "Utility",
        subcategories: ["Waste"],
      },
    ],
    description:
      "The project involves the design, financing, construction, operation, and maintenance of a biodegradable source separated waste treatment and residual combustible waste treatment facility capable of processing up to 3,000 metric tons of municipal solid waste (MSW) per day and generating 36 MWe (Net).",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 395 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.gov.ph/ppp_projects/quezon-city-integrated-solid-waste-management-facility-project/",
    ESGRating: "4.5",
    image: PiyunganWasteTreatment,
    map: "Philippine, Quezon",
    contactName: "",
    contactEmail: "info@ppp.gov.ph",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Republic of the Philippines Public-Private Partnership Center",
    concessionPeriod: "",
  },
  {
    key: "66",
    title: "Smart City ICT Project in New Clark City",
    Location: "Philippine",
    City: "New Clark City",
    categories: [
      {
        name: "Built Environment",
        subcategories: ["Smart City"],
      },
    ],
    description:
      "The Project involves the provision of smart city services to citizens, locators and/or government agencies in New Clark City (NCC). It aims to deliver critical services to the citizens of NCC in a smarter, greener, friendlier and more people-centric manner through the use of best-in-class technologies.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 0.19 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.gov.ph/ppp_projects/smart-city-ict-project-in-new-clark-city/",
    ESGRating: "4.5",
    image: NewDelhiRailwayStationRedevelopment,
    map: "Philippine, New Clark City",
    contactName: "",
    contactEmail: "info@ppp.gov.ph",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Republic of the Philippines Public-Private Partnership Center",
    concessionPeriod: "",
  },
  {
    key: "67",
    title:
      "Upgrading of Gabtoli-Savar-Nabinagar into 4 Lane Expressway on PPP Basis",
    Location: "Bangladesh",
    City: "Dhaka and Manikganj District",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description: `Dhaka-Aricha National Highway connects the western part of the country to Dhaka, the capital city. It forms an important section of the N5 route which carries a significant amount of traffic from the south western part of the country towards the capital city. There is a heavy flow of traffic on the route, with significant volumes of commercial traffic and heavy good vehicles.

    The upgrading of Gabtoli-Nabinagar highway into 6-Lane Expressway on PPP Basis project, as part of N-5 which facilitates the intercity movement of cargo and passengers entering the Dhaka connecting 28 districts of northern and north-western part of the country. The Project Stretch is approx. 24.445 Km long and forms an important part of several connectivity initiatives such as BIMSTEC, SAARC, SASEC etc.
    
    The stretch starts after crossing the Aminbazar bridge and passes through Amin bazar, Hemayetpur intersection and Savar Bazar and then passes Nabinagar intersection at National Monument Site followed by passing Nabinagar-Chandra R505 (a link between N5 and N4) and ends at Bipile intersection with Abdullahpur-Ashulia-EPZ Road.`,
    InvestableRating: "80",
    EstimatedProjectCost: "USD 500 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink: "https://www.pppo.gov.bd/projects-hemayetpur-road.php",
    ESGRating: "4.5",
    image: ExpressTransport,
    map: "Bangladesh, Dhaka and Manikganj District",
    contactName: "Aktarunnahar",
    contactEmail: "dadmin@pppo.gov.bd",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Authority Bangladesh",
    concessionPeriod: "",
  },
  {
    key: "68",
    title:
      "Improvement of Hatirjheel (Rampura Bridge)-Shekherjaiga-Amulia-Demra Road",
    Location: "Bangladesh",
    City: "Dhaka",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "National Highway N1 and National Highway N2 connects Dhaka to two very important cities, Chittagong & Sylhet. Moreover, traffic from these highways enters Dhaka around the same corridor. This creates significant congestion in the south of Dhaka for vehicles entering Dhaka using Highway N1 & N2 and heading towards the northern part of Dhaka. Therefore, RHD is proposing a new high-quality gateway of Dhaka through the development of 13 km 4-lane access controlled tolled expressway from Chittagong Road to Hatirjheel, with a trunk road from Tarabo connecting the expressway at Demra.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 200-500 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "http://pppo.gov.bd/projects-improvement-of-hatirjheel-shekherjaiga-amulia-demra-road.php",
    ESGRating: "4",
    image: ExpressTransport,
    contactName: "",
    map: "Bangladesh, Dhaka",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "PPP Authority Bangladesh",
    concessionPeriod: "",
  },
  {
    key: "69",
    title:
      "Initiative PPP Project: Western Bangkok Outer Ring Road Intercity Motorway (Bang Khun Thian - Bang Bua Thong segment)",
    Location: "Thailand",
    City: "Bangkok",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The project is an elevated toll road along the 2nd Western Bangkok Outer Ring Road with a total length of 38 kilometers. The route alignment starts at Bang Khun Thian interchange, the southern section of Kanchanapisek Ring Road of the intercity motorway No.9 project, and ends at the Bang Bua Thong intersection.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 1,593 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "4",
    image: ExpressTransport,
    map: "Thailand, Bangkok",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "30",
  },
  {
    key: "70",
    title:
      "Initiative PPP Project: Light Rail Double Track Transit System (Bang Na – Suvarnabhumi Airport)",
    Location: "Thailand",
    City: "Bangkok",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Railways"],
      },
    ],
    description:
      "The project is a light-rail double-track transit system (Bang Na – Suvarnabhumi Airport) with an evaluated structure. The route has a total length of 14.4 kilometers, 14 stations, and a maintenance depot. The route alignment starts from Bang Na Intersection, travels along Bang Na – Trat Road, and ends at Suvarnabhumi Airport.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 793 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "3",
    image: NewDelhiRailwayStationRedevelopment,
    map: "Thailand, Bangkok",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "71",
    title:
      "Initiative PPP Project: Monorail Grey Line (Watcharaphon – Thong Lo and Phra Khanong – Rama III)",
    Location: "Thailand",
    City: "Bangkok",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Railways"],
      },
    ],
    description:
      "The project is an elevated single track monorail. The segment of Watcharaphon – Thong Lo has a total length of 16.25 kilometers and 15 stations), and can transfer to MRT pink, yellow, and orange lines. The segment of Phra Khanong – Rama III has a total length of 12.2 kilometers and 12 stations, and passengers can transfer to MRT blue line.",
    InvestableRating: "95",
    EstimatedProjectCost: "USD 1,307 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "4",
    image: NewDelhiRailwayStationRedevelopment,
    map: "Thailand, Bangkok",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "72",
    title: "Initiative PPP Project: Monorail Grey Line (Lumpini – Tha Pra)",
    Location: "Thailand",
    City: "Bangkok",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Railways"],
      },
    ],
    description:
      "The project is an elevated single track monorail in the segment from Lumpini to Tha Pra.",
    InvestableRating: "50",
    EstimatedProjectCost: "USD 1,307 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "2",
    image: NewDelhiRailwayStationRedevelopment,
    map: "Thailand, Bangkok",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "73",
    title:
      "Initiative PPP Project: Development of Cargo Berth in Support of Singkhon Pass (East-West Ferry Service for Freight Transportation and Tourism)",
    Location: "Thailand",
    City: "",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Ports"],
      },
    ],
    description:
      "The project aims to improve the quality of public services, marine transport and traffic systems. The Cruise Home Port in the upper Gulf of Thailand will enhance the country’s competitiveness, promote marine tourism by cruise according to the Transport and Logistics Integrative Plan",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 7 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "4",
    image: AmbonPort,
    map: "Thailand",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "74",
    title: "Initiative PPP Project: Development of Dry Port",
    Location: "Thailand",
    City: "",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Ports"],
      },
    ],
    description:
      "The project aims to link intermodal transport between road and rail toward the port, serve as a distribution center to domestic destinations, and provide cargo storage and facilities. The Customs service point is also located within the project site to facilitate importers and exporters. The port location also facilitates the goods shipment to business establishments in its vicinity. The dry port is PAT’s ancillary business that leads to the continuous business growth of the country’s major ports - Bangkok Port and Laem Chabang Port. The project site has a total land area of 240,000 square meter, Tambon Muang Wan, Amphoe Nam Phong, Khon Kaen.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 86 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "3",
    image: AmbonPort,
    map: "Thailand",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "75",
    title: "Initiative PPP Project: Khlong Toei Wastewater Treatment Facility",
    Location: "Thailand",
    City: "Bangkok",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "The objective of the project is to resolve the wastewater problems in the Chao Phraya River and in the other canals, namely Saen Saep, Tan, Phra Khanong, Bang Na, Phai Singto, Bang Chak, Toei, and Hua Lamphong Canals. The project will be able to collect and clean 360,000 cubic meters of wastewater/day in its service areas covering 71 square kilometers.",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 354 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "4.5",
    image: BangkokWastewaterProject,
    // map: "Thailand, Bangkok",
    map: "Thailand, Bangkok",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "76",
    title:
      "Initiative PPP Project: Nong Bon Swamp Wastewater Treatment Facilit",
    Location: "Thailand",
    City: "",
    categories: [
      {
        name: "Utility",
        subcategories: ["Water"],
      },
    ],
    description:
      "The objective of the project is to resolve the wastewater problems in Prawet Burirom, Palat Priang, Nong Bon, Makham Thet, Khlet, and Achan Phon canals. The project will be able to collect and clean 135,000 cubic meters of wastewater per day in its service areas that covers 63 square kilometers.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 225 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.sepo.go.th/tinymce/plugins/filemanager/thumbs/PPP%20Delivery%20Plan%202020-2027_Mar2020%20(EN).pdf",
    ESGRating: "4",
    image: BangkokWastewaterProject,
    map: "Thailand",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Public-Private Partnership Project Delivery Plan 2020 – 2027",
    concessionPeriod: "",
  },
  {
    key: "77",
    title: "Phnom Penh Logistics Complex",
    Location: "Cambodia",
    City: "Phnom Penh",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Logistics"],
      },
    ],
    description:
      "The YCH Group proposes a state-of-the-art logistics facility in Phnom Penh, Cambodia. This logistics complex aims to provide various logistics solutions to businesses of all sizes and industries. The project involves the development, design, financing, construction, and operation of a modern and world-class logistics and warehouse complex. Its goal is to enhance the price, speed, quality, and cost-effectiveness of a wide range of logistics and supply chain offerings and services that are crucial to the continuous progress and market competitiveness of Cambodia in the region.",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 220 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.mef.gov.kh/detail/phnom-penh-logistics-complex?currentProjectListPid=190&cHash=409720af9e57ba30cafc54786ddde24f",
    ESGRating: "3",
    image: Logistics,
    // map: "https://maps.google.com/maps?q=Cambodia,Phnom%20Penh&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed" ,
    map: "Cambodia,Phnom Penh",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Ministry of Economy and Finance General Department of Public-Private Partnerships",
    concessionPeriod: "",
  },

  {
    key: "78",
    title: "Phnom Penh-Siem Reap-Poi Pet Expressway",
    Location: "Cambodia",
    City: "Siem Reap, Banteay Meancheyh",
    categories: [
      {
        name: "Transportation",
        subcategories: ["Expressway"],
      },
    ],
    description:
      "The Government is planning to develop, design and construct a safe and modern, approximately 400 kilometer long, international-standard four-lane expressway with supporting infrastructure and facilities. The first step will be to establish a connection between Phnom Penh and Siem Reap province, which is one of the most popular tourist destinations in Cambodia. Following this phase, the highway will be laid out to connect Siem Reap to Poipet city, which is located on the Cambodian side of the border with Thailand.",
    InvestableRating: "40",
    EstimatedProjectCost: "USD 220 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://ppp.mef.gov.kh/detail/phnom-penh-siem-reap-poi-pet-expressway?currentProjectListPid=190&cHash=409720af9e57ba30cafc54786ddde24f",
    ESGRating: "4",
    image: BandungMetropolitanUrbanRailway,
    map: "Cambodia, Banteay Meanchey",
    // map: "https://maps.google.com/maps?q=Cambodia,Siem%20Reap,%20Banteay%20Meanchey&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed",
    contactName: "",
    contactEmail: "",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Ministry of Economy and Finance General Department of Public-Private Partnerships",
    concessionPeriod: "",
  },
  {
    key: "79",
    title: "Pameungpeuk Hospital",
    Location: "Indonesia",
    City: "Pameungpeuk",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Hospital"],
      },
    ],
    description:
      "Pameungpeuk Hospital is the Class C hospital with a service capacity of 15,000 out patients per year and 5,000 in patients. To improve health services in the south West Java, the provincial government will develop Pameungpeuk Hospital to become Class B Hospital with increasing the number of human resources and improving health service facilities",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 22.78 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
    ESGRating: "2",
    image: Hospital1,
    map: "Pameungpeuk Indonesia",
    contactName: "Mohammad Taufiq Budi Santoso",
    contactEmail: "simpulkpbujabar@gmail.com",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
    concessionPeriod: "",
  },
  {
    key: "80",
    title: "Jampang Kulon Hospital",
    Location: "Indonesia",
    City: "South Sukabumi",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Hospital"],
      },
    ],
    description:
      "Jampang Kulon Hospital is currently the only hospital in South Sukabumi, with services area covering Cianjur Regency and Sukabumi Regency. At present the hospital's status is Class D type, and will be upgraded to the Class C Hospital. Considering that this Hospital planned to be a referral center with the largest and most comprehensive health facilities in the Sukabumi Regency and Southern Cianjur",
    InvestableRating: "70",
    EstimatedProjectCost: "USD 30 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "http://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
    ESGRating: "4.5",
    image: Hospital3,
    // map: "https://maps.google.com/maps?q=Indonesia,%20South%20Sukabumi&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=&amp;output=embed" ,
    map: "South Sukabumi, Indonesia",
    contactName: "Mohammad Taufiq Budi Santoso",
    contactEmail: "simpulkpbujabar@gmail.com",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
    concessionPeriod: "",
  },
  {
    key: "81",
    title: "Al-Ihsan Hospital",
    Location: "Indonesia",
    City: "West Java",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Hospital"],
      },
    ],
    description:
      "Al-Ihsan Hospital currently a Class-B Hospital owned by West Java Province. The number of patients handled by Al Ihsan Hospital reaches 800 - 1000 patients per day. To develop Al-Ihsan into a Class-A Hospital with more complete facilities, the Provincial Government invites partners from private / business entities that are experienced in Hospital management, to increased health services",
    InvestableRating: "80",
    EstimatedProjectCost: "USD 26 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "https://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
    ESGRating: "4",
    image: Hospital2,
    map: "West Java, Indonesia",
    contactName: "Mohammad Taufiq Budi Santoso",
    contactEmail: "simpulkpbujabar@gmail.com",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
    concessionPeriod: "",
  },
  {
    key: "82",
    title: "Sidawangi Pulmonary Hospital",
    Location: "Indonesia",
    City: "West Java",
    categories: [
      {
        name: "Social Infrastructure",
        subcategories: ["Hospital"],
      },
    ],
    description:
      "Sidawangi Pulmonary Hospital, is currently a Class B specialty lung disease hospital. Located on the border between Kab. Cirebon and Kuningan. Initially it functioned as a sanatorium for tuberculosis which was built by the Government of the Netherlands East Indies in 1939. In 1978, it was changed to Hospital status and in 2002 it was handed over to West Java Province. In 2008 the status officially became Lung Hospital in West Java Province. As an effort to develop, this Paru Sidawangi Hospital plans to improve its facilities and services to become Class A General Hospital",
    InvestableRating: "90",
    EstimatedProjectCost: "USD 26 Million",
    TechInvolved: "",
    ProjectStage: "Planning",
    SupportLink:
      "http://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
    ESGRating: "4.5",
    image: Hospital1,
    map: "West Java, Indonesia",
    contactName: "Mohammad Taufiq Budi Santoso",
    contactEmail: "simpulkpbujabar@gmail.com",
    financialFeasibility: {
      irr: "",
      npv: "",
    },
    source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
    concessionPeriod: "",
  },
  // {
  //   key: "83",
  //   title: "KPMG on-going mandate",
  //   Location: "Vietnam",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Solar", "Wind"]
  //     }
  //   ],
  //   description: "Opportunity to invest in a 2GW+ renewable energy platform for up to 49% with a pathway to majority",
  //   InvestableRating: 85,
  //   EstimatedProjectCost: "USD 250 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 3,
  //   image: EnergyTwo,
  //   map: "Vietnam",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "8-10%",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  // {
  //   key: "84",
  //   title: "KPMG on-going mandate",
  //   Location: "Indonesia",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Solar"]
  //     }
  //   ],
  //   description: "1GW Renewable Energy Procurement in Indonesia",
  //   InvestableRating: 78,
  //   EstimatedProjectCost: "USD 25 to 50 Million per asset",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 2,
  //   image: EnergyThree,
  //   map: "Indonesia",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "Not Disclosed",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  // {
  //   key: "85",
  //   title: "KPMG on-going mandate",
  //   Location: "Indonesia",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Hydro"]
  //     }
  //   ],
  //   description: "Opportunity to invest in an operating mini hydro asset (12MW)",
  //   InvestableRating: 90,
  //   EstimatedProjectCost: "USD 40-60 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 4,
  //   image: JointDevelopmentofHydropower,
  //   map: "Indonesia",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "Not Disclosed",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  // {
  //   key: "86",
  //   title: "KPMG on-going mandate",
  //   Location: "Singapore",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Solar"]
  //     }
  //   ],
  //   description: "Opportunity to invest in one of the fastest-growing solar C&I platforms in Singapore with 21.5MWp contracted portfolio with blue-chip customer base with clients such as international industrial conglomerates, state-owned enterprises, and clear pathway to scaling up to implement over 100 MWp in Singapore over the next 3 years.",
  //   InvestableRating: 88,
  //   EstimatedProjectCost: "USD 20-100 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 3,
  //   image: SolarPowerProject,
  //   map: "Singapore",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "10-12%",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  // {
  //   key: "87",
  //   title: "KPMG on-going mandate",
  //   Location: "Singapore",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Solar"]
  //     }
  //   ],
  //   description: "The company seeks an investor with a strong commitment to provide funding for the development of a robust pipeline of projects with reputable C&I and private clients. The key objective of this capital raise initiative is to secure an anchor investor with a capital commitment of at least USD 10mn for deployment within the next 12 months.",
  //   InvestableRating: 82,
  //   EstimatedProjectCost: "USD 10 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 2,
  //   image: Solar1,
  //   map: "Singapore",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "9-10%",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  // {
  //   key: "88",
  //   title: "KPMG on-going mandate",
  //   Location: "Australia",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Solar", "Wind"]
  //     }
  //   ],
  //   description: "The opportunity is to deploy capital into a fund managed by Octopus Australia, which owns a portfolio of 450MW of operating assets, defined pipeline of 4.5GW and a further pipeline of 6.2GW, located in the eastern states of Australia (New South Wales, Queensland, Victoria). The assets span across technologies like onshore wind, solar and co-located BESS.",
  //   InvestableRating: 92,
  //   EstimatedProjectCost: "USD 2,000 Million - equity commitment requirement",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 4,
  //   image: Solar2,
  //   map: "Australia",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "10-12%",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  // {
  //   key: "89",
  //   title: "KPMG on-going mandate",
  //   Location: "Vietnam",
  //   City: "",
  //   categories: [
  //     {
  //       name: "Energy",
  //       subcategories: ["Solar", "Wind"]
  //     }
  //   ],
  //   description: "",
  //   InvestableRating: 75,
  //   EstimatedProjectCost: "USD 120 Million",
  //   TechInvolved: "",
  //   ProjectStage: "Capital Raising",
  //   SupportLink: "",
  //   ESGRating: 3,
  //   image: Solar3,
  //   map: "Vietnam",
  //   contactName: "Not Disclosed",
  //   contactEmail: "Not Disclosed",
  //   financialFeasibility: {
  //     irr: "Not Disclosed",
  //     npv: "Not Disclosed"
  //   },
  //   source: "KPMG Intelligence",
  //   concessionPeriod: "Not Disclosed"
  // },
  {
    key: "90",
    title: "Sale of EDC by Macquarie and GIC",
    Location: "Philippine",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Other"]
      }
    ],
    description: "The potential sale of a 30% stake in Philippine renewables developer Energy Development Corp (EDC) by Macquarie and GIC. EDC has an installed capacity of about 1.48 GW, of which the majority is geothermal energy.",
    InvestableRating: 80,
    EstimatedProjectCost: "USD 2000 Million",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: TheBantenWindFarmPowerDevelopment,
    map: "Philippine",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Infralogic",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "91",
    title: "SUN Energy equity raise",
    Location: "Singapore",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"]
      }
    ],
    description: "The deal involves SUN Energy's equity raise for its expansion plans. SUN Energy sought to sell up to USD 200m of equity last year in a Nomura-run process, but that process failed due to a lack of interest. Established in 2016, SUN Energy has installed and contracted 150 MWp worth of C&I solar projects in Indonesia, as well as 160 MWp across Australia, Thailand, and Vietnam. SUN Energy is a subsidiary of Solar United Network PTE. Ltd (SUN) Group, a solar panel developer headquartered in Singapore.",
    InvestableRating: 85,
    EstimatedProjectCost: "USD 200 Million",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: EnergyFive,
    map: "Singapore",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Infralogic",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "92",
    title: "Exxon gas station divestment",
    Location: "Singapore",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Other"]
      }
    ],
    description: "The deal involves the sale of gas stations by Exxon Mobil Corp in Singapore for approximately USD 1bn. Exxon has a network of 59 filling stations under the Esso brand in Singapore.",
    InvestableRating: 70,
    EstimatedProjectCost: "USD 1000 Million",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 1,
    image: Logistics,
    map: "Singapore",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Infralogic",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "93",
    title: "NEFIN: divestment of ACEN's stake",
    Location: "Singapore",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"]
      }
    ],
    description: "The deal involves NEFIN, a 50:50 joint venture between NEFIN and ACEN developing C&I Solar PV projects raising equity. NEFIN was established in 2021 to own 21 MW of operating rooftop solar assets in Asia. It has delivered over 300 MW of utility-scale and C&I solar PV systems. Projects include a 10 MW flagship rooftop PV system for Bosch in China, a 25 MW solar project for Lotus Malaysia",
    InvestableRating: 88,
    EstimatedProjectCost: "USD 250 Million",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: EnergySeven,
    map: "Singapore",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Infralogic",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "94",
    title: "AGP Sustainable Real Assets",
    Location: "Singapore",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar", "Wind"]
      }
    ],
    description: "Singapore-based AGP Sustainable Real Assets, a portfolio company of Stonepeak, is sounding out potential investors to raise up to USD 450m for energy transition, according to two sources familiar. AGP Sustainable Real Assets received a USD 300m investment from Stonepeak in November 2023, one of the sources said. Stonepeak did not disclose the amount in its announcement at the time. AGP plans to combine the new investment with the Stonepeak capital to fund an investment platform, said the source. AMPYR Energy will provide engineering, procurement and construction work for AGP’s renewables assets, he added. Stonepeak closed its first Asia infrastructure vehicle at USD 3.3bn in March. Founded in 2019, AGP operates renewables platform AMPYR Energy, which is developing over 10 GW in solar, 1 GW in onshore wind, and 1 GW in battery storage across India, Australia, UK, Germany, the Netherlands and the US. It also operates AMPYR Distributed Energy, an onsite clean energy assets developer. Besides renewables, AGP manages community housing developer Assetz Property Group and AGP DC, a digital infrastructure investment platform. AGP DC, along with Stonepeak’s Digital Edge and the National India Infrastructure Fund, is building a 300 MW data centre project in Mumbai.",
    InvestableRating: 91,
    EstimatedProjectCost: "USD 450 Million",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 4,
    image: EnergyEight,
    map: "Singapore",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Inframation - transactions",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "95",
    title: "PTT",
    Location: "Thailand",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Other"]
      }
    ],
    description: "Merger of certain assets, new equity investment being considered. PTT [BKK:PTT] has picked Bualuang Securities Pcl and UBS Group AG to review the Thai energy group's downstream assets, a newswire reported, citing people familiar with the matter. Options include introducing a new equity investor or merging certain businesses, the Bloomberg item said. Deliberations are at a preliminary stage and the company may choose not to proceed with any transaction.",
    InvestableRating: 79,
    EstimatedProjectCost: "> USD 500m,USD 100m-500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: EnergyNine,
    map: "Thailand",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "96",
    title: "Manila Electric Co (Meralco)",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas", "Solar"]
      }
    ],
    description: "Manila Electric Co (Meralco) [PSE:MER], the energy subsidiary of Philippines-based infrastructure conglomerate Metro Pacific Investments, will appoint three to four banks to arrange a syndicate loan to fund the acquisition of San Miguel Corp’s [PSE:SMC] two gas-fired power plants, Chief Financial Officer Betty Siy-Yap told this news service. The appointments will be firmed up by the end of this year and the total amount will be around USD 1.3bn, or 40% of the total acquisition cost, Siy-Yap said on the sidelines of Meralco's 3Q24 earnings briefing on 28 October. The gas plants were valued at USD 3.3bn, as announced in March. The borrowing terms will be finalized once approval from the Philippine Competition Commission is secured, the CFO said, adding that it is expected to arrive shortly. Meralco is set to acquire San Miguel Global Power Holdings Corp’s two gas-fired power plants through Chromite Gas Holdings (CGHI), a 60:40 joint venture with Therma NatGas Power Inc, a unit of Aboitiz Power [PSE:AP]. The Energy Regulatory Commission has already approved the power supply agreement (PSA) for the 1,320-megawatt (MW) power plant under Excellent Energy Resources Inc, while it has given its nod for the PSA for 910 MW out of the 1,278MW output of the Ilijan plant, Siy-Yap added. Meanwhile, Meralco is also finalizing the terms for the syndicated loan to finance the development of Terra Solar’s 3.5-gigawatt solar farm, a project wholly owned by SP New Energy Development Corp [PSE:SPNEC]. Meralco’s renewable energy unit, MGen Renewable Energy, owns 55.96% of SPNEC, as disclosed. Siy-Yap said they will appoint six banks to syndicate the debt for the facilities and operations while three banks will be named to syndicate the loan needed for the land. According to a previous announcement, the Terra Solar project covers around 3,500 hectares or the equivalent to the size of 83,300 basketball courts. The bank loan amount is likely to be over PHP 150bn (USD 2.6bn), but this would depend on the final project cost, Siy-Yap said. Terra Solar requires PHP 200bn (USD 3.6bn) to implement the project fully, Mergermarket reported in February this year. Terra Solar Phase 1 will be completed and deliver 2,500 MW of power by 2026 and the balance under Phase 2 will be delivered a year later, according to Meralco’s 3Q24 earnings statement.",
    InvestableRating: 87,
    EstimatedProjectCost: "> USD 500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: EnergyTen,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "97",
    title: "Alternergy Holdings Corp",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar"]
      }
    ],
    description: "Company still considering the debt/equity splitCan acquire targets of at least 100 MW capacityAlternergy Holdings [PSE:ALTER], a Philippines-based renewable energy (RE) developer, is hearing banker pitches for its upcoming fundraising that would back its domestic and offshore expansion and possible acquisitions, co-founder and Chairman Vince Perez told this news service.The company is still considering the equity/debt split of the fundraising as it wants to maintain a prudent debt-to-equity (D/E) ratio, which now stands at 1.2x, the chairman said on the sidelines of the 56th Financial Executives of the Philippines (FINEX) Conference (Day 1) today (30 September).The structure of the equity fundraising is still being weighed as the company is reviewing the proposals from the bankers, Perez added.Local media reports earlier this month said the company has earmarked PHP 15bn (USD 268m) in capital expenditures for its energy projects with total capacity of 191 megawatts (MW), which will be completed in 2025 and 2026. The reports said 25% of this will come from equity and the rest will be from debt.Perez said the company is completing the 15.3 MW solar and battery project in Palau, which it plans to replicate in other Pacific islands/Oceania territories. He declined to specify the countries that it has been looking at, but he did say that the projects are much larger than the one it is developing in Palau.Alternergy is also looking to acquire domestic and offshore projects of at least 100 MW. Perez, who was the Philippines’ former secretary of the Department of Energy (DOE), said the company is particularly keen on projects that require its expertise in project finance.The Philippines aims to have 35% of its overall energy to be generated from renewable energy (RE) sources by 2030 and 50% by 2040. According to the DOE, it has awarded a total of 1,327 renewable energy service contracts, with 5.8 GW already installed as of March 2024 and another potential capacity of about 137.8 GW in the coming years. Most of the renewable energy capacity comes from solar, hydro and wind, accounting for almost 90% of the total renewable energy contracts awarded, it said.",
    InvestableRating: 84,
    EstimatedProjectCost: "USD 100m-500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: EnergyEleven,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: ""
  },
  {
    key: "98",
    title: "Alternergy Holdings Corp",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar", "Wind"]
      }
    ],
    description: "PHP 15bn allocated, 25% equity, 75% debt 191-megawatts projects to be completed in 2025-2026 Alternergy Holdings [PSE:ALTER], a Philippines-based renewable energy (RE) developer, is seeking to raise new capital, reported Business World on 27 September. The report cited Gerry Magbanua, the president of Alternergy, who said that the company has already allocated PHP 15bn (USD 268m) to finance the capital requirements of energy projects totalling 191-megawatts. The energy projects are planned to be completed in 2025 and 2026. Of the capital expenditure amount, approximately 25% would come from equity while the remainder from debt. The company is investigating opportunities to raise the necessary capital. Previously, the company announced that it has raised PHP 20bn in new capital since its IPO in March 2023.",
    InvestableRating: 83,
    EstimatedProjectCost: "USD 100m-500m,USD 50m-100m,USD 10m-50m,< USD 10m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: EnergyOneTwo,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "99",
    title: "Emerging Power Inc.",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Natural Gas"]
      }
    ],
    description: "Emerging Power Inc. (EPI), an 86.29% subsidiary of Nickel Asia Corp. (NAC) [PSE:NIKL], is exploring various options for capital raising ahead of its potential initial public offering (IPO) in the next three years, NAC Senior Vice President Jose Bayani Baylon told this news service. Baylon said that EPI is considering alternative capital-raising strategies in the near future, including a potential stake sale or a green bond offering. The company had previously engaged UBS for advice on a green bond sale, initially contemplated in 2022, but unfavourable market conditions at that time led to a pause on those plans, Baylon said. While IPO plans remain on the horizon, Baylon emphasized that it is not a near-term priority, especially given the sluggish public markets in the region. Year to date, the Philippine Stock Exchange index rose 12.44% to 7252.32. This marks an 18.06% increase as compared to the same period last year. For now, Baylon said that EPI finds itself in a robust financial position, allowing it to take a measured approach to fundraising. This financial stability affords EPI the flexibility to explore different avenues for capital without immediate pressure, he added. “We have the money. We can use NAC funds to support EPI's growth,” Balyon said. Baylon also emphasized the importance of solidifying EPI’s project portfolio before making any moves toward public listing. “We want a proof of purchase. We don’t want it half-baked,” he said, reinforcing the company’s commitment to presenting a compelling and mature offering to investors. Looking ahead, Baylo said that EPI is optimistic about its growth prospects, with an eye toward 2025 as a potentially transformative year for the company. “Maybe in 2025, [it] will be a mega story for EPI,” Baylon said, with EPI projected to achieve half of its goal of developing one gigawatt (GW) of renewable energy projects. EPI currently has operational renewable energy projects with a total capacity of 174 megawatts (MW). About 487 MW are projects under construction and 1.8 GW in development stages. EPI's annual revenue was USD 4m in 2024, based on the company’s website.",
    InvestableRating: 81,
    EstimatedProjectCost: "USD 100m-500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: BuildOne,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "100",
    title: "Energy Absolute Public Company Limited",
    Location: "Thailand",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar", "Wind"]
      }
    ],
    description: "Energy Absolute [BKK:EA], a Bangkok-based renewable power-focused company, is looking to raise between THB 12 and THB 15bn (USD 446m) in a private share sale, according to a newswire report on 6 September. Citing CFO Vasu Klomkliang, Bloomberg reported that discussions between Energy Absolute and some potential strategic partners in Thailand are underway over the fundraise, which the company aims to finalize by the end of 1Q25. The company is also working on setting up an infrastructure fund as a backup plan for the fundraise, according to the item. Energy Absolute could sell its renewable power projects to the infrastructure fund, which will be financed by capital raised from the public, Vasu was cited as saying in the report.",
    InvestableRating: 89,
    EstimatedProjectCost: "USD 100m-500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: BuildTwo,
    map: "Thailand",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Medium-term pursuit",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "101",
    title: "Philippine Tank Storage International (Holdings) Inc.",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Solar", "Other"]
      }
    ],
    description: "Singapore's Keppel Infrastructure Trust [KEPL.SI] and Philippines' Metro Pacific Investments Corp [MPCFF.PK] (MPIC), the owners of Philippine Tank Storage International, are looking to attract a strategic partner for the company that operates Philippine's largest storage facility for petroleum import, a newswire reported, citing people familiar with the matter. Keppel and MPIC are evaluating a transaction which might value the asset at as much as USD 500m, one of the people told Reuters. They are engaging in preliminary talks with potential investors and have yet to determine how large a minority stake they might sell, the unnamed people said. The proceeds of the investment will support the company’s growth and enhance the asset's value, one of the people told Reuters.",
    InvestableRating: 76,
    EstimatedProjectCost: "> USD 500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: BuildThree,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "102",
    title: "Kayan Hydro Energy (hydropower project)",
    Location: "Indonesia",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Hydro"]
      }
    ],
    description: "Kayan Hydro Energy (KHE) has met with several Japanese companies as it seeks investors to co-develop a hydropower project in Indonesia’s East Kalimantan province after Sumitomo Corporation pulled out, Mergermarket reported citing Bisnis Indonesia today. The meeting, held on 19 August, was attended by several Japanese executives, including those from Itochu Corporation, Marubeni Corporation's Indonesian subsidiary - Matlamat Cakera Canggih - Sojitz's Indonesian unit, Electric Power Development Co, Tokyo Electric Power Company and Kansai Electric Power Co, the Indonesian-language daily reported. The companies have shown interest, the newspaper cited KHE's Operations Director Sapta Nugraha as saying. The development of Kayan 1 will require an estimated USD 17.8bn, including supporting infrastructure such as transmission lines and a 9 GW substation. While KHE is scouting for potential Japanese investors, it should retain control, the newspaper reported, citing Edi Prio Pambudi, deputy coordinating minister for international economic cooperation at Indonesia’s Coordinating Ministry for Economic Affairs. Pambudi said that since the Kayan River affects livelihoods, the Indonesian government is not keen for its management to be controlled by foreign entities.",
    InvestableRating: 85,
    EstimatedProjectCost: "NA",
    TechInvolved: "",
    ProjectStage: "Early-stage",
    SupportLink: "",
    ESGRating: 3,
    image: BuildFour,
    map: "Indonesia",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "103",
    title: "FECON Invest Corp",
    Location: "Vietnam",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"]
      }
    ],
    description: "FECON Corporation [HOSE:FCN], a Vietnam-based construction and underground engineering firm, is exploring funding options, including bringing in a strategic investor for its infrastructure and energy unit FECON Invest JSC, FECON’s spokesperson told Mergermarket. The company would like to engage a foreign strategic partner with strong financial capabilities that could support FECON in developing new renewable energy (RE) projects in the pipeline. Details of the fundraising exercise should hinge on discussions with specific investors, and the company is receptive to advisory pitches for the deal, he added. The VND 2.06trn (USD 81.6m)-market cap firm holds 90.52% of FECON Invest as of end-2023, according to its financial statements. Separately, as discussions with a potential investor to sell its Soc Trang wind power plant has fallen through, FECON is now open to fresh investor approaches for the wind asset disposal, the spokesperson said without elaborating on more details. As reported by this news service in June last year, the shareholders of FECON’s Quoc Vinh Soc Trang Wind JSC, the operator of 30MW onshore Soc Trang wind power plant, was working to finalize the transfer of their entire stake (51%) to Thailand’s BG Energy Solution Company Limited (BGE). Proceeds from the fundraising and/or the asset disposal will be earmarked to invest in developing two new solar power projects: the 90MW Vinh Hao 6.2 solar farm in the southern Binh Thuan province and the 50MW Binh Phuoc Solar Power project, with a total investment capital of up to USD 200m, according to the spokesperson. FECON aims to become one of Vietnam’s leading infrastructure construction and development companies by 2030, FECON’s Chairman Pham Viet Khoa said during its annual general meeting held in April this year. To realize this goal, the firm will also focus on liquefied natural gas (LNG) power projects and infrastructure projects (seaport, airport, railway, urban underground, water treatment, among others), aligning with the government’s development strategies. In the short term, FECON will also partially join big and high-technique infrastructure projects to maintain its business activities. Aside from preferential markets including Laos, Cambodia, and Myanmar, the company will do research and consider expanding its coverage to other countries like Taiwan (China) or Bangladesh under the joint venture (JV) partnership form with large companies, the chairman stated. In April this year, the firm announced HD Capital became its large shareholder after acquiring an 11.12% stake in FECON. Other major shareholders include Japan’s Raito Kogyo having a 25.51% stake while Red One Infrastructure Fund (a member fund of Red Capital), holding a 10.16% stake as of end-2023, as disclosed by the company. FECON aims to generate a net revenue of VND 4trn (USD 158m) and a net profit of VND 60bn (USD 2.4m) in 2024, up 39% and 243% year on year, respectively, as announced.",
    InvestableRating: 88,
    EstimatedProjectCost: "USD 100m-500m,USD 50m-100m,USD 10m-50m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: BuildFive,
    map: "Vietnam",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
  },
  {
    key: "104",
    title: "CleanTech Global Renewables",
    Location: "Philippines",
    City: "",
    categories: [
      {
        name: "Energy",
        subcategories: ["Wind"]
      }
    ],
    description: "CleanTech Global Renewables, a Philippines-based independent power producer, is seeking a new equity investor for its wind portfolio, according to four sources familiar with the matter. The developer aims to offload its stake in the wind platform and is targeting international buyers, the sources said. Discussions remain in the early stages and the size of the stake on offer has yet to be decided, they said. The process of finding a buyer has started with Manila-based Mabuhay Capital running the sellside, the sources said. CleanTech’s wind portfolio has 1 GW of onshore and offshore assets under development, said one of the sources. CleanTech should get healthy interest from foreign players looking at Philippines wind, an energy-focused advisor said. Given the lack of progress in Vietnam and Indonesia, some investors are willing to take more risks in the Philippines, he added. Last May, CleanTech onboarded BlackRock Alternatives as a backer for its solar platform. Blackrock, through its public-private finance vehicle Climate Finance Partnership, partnered with CleanTech to support its target of developing 1 GW of solar in the Philippines by 2026. Mabuhay Capital was the financial advisor on the solar transaction, sister title Mergermarket reported. CleanTech’s renewables portfolio includes the 133 MW Cagayan North Solar Power Plant in northern Luzon, a joint venture with ACEN Corp undergoing completion, as well as the pre-development stage 100 MWp CleanTech Renewable Energy 4 solar project, according to the company’s official website. In addition, CleanTech is developing the 22 MW San Ildefonso Alternative Energy in Bulacan province and 20 MW OneManaoagSolar solar farms in Pangasinan province, both of which are north of Manila and still under construction.",
    InvestableRating: 90,
    EstimatedProjectCost: "> USD 500m,USD 100m-500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 4,
    image: BuildSix,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
      irr: "Not Disclosed",
      npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
  },
{
    key: "105",
    title: "Citicore Renewable Energy (CREC)",
    Location: "Philippines",
    City: "",
    categories: [
        {
            name: "Energy",
            subcategories: ["Solar"]
        }
    ],
    description: "Citicore Renewable Energy (CREC) is evaluating multiple financing alternatives including, but not limited to, green bonds, although it is yet to finalise a plan, according to a stock exchange filing today. The Philippine solar power developer issued the clarification in response to a 9 June report by the Manila Bulletin, which stated that CREC is planning a green bonds issue next year to help finance its USD 3bn five-year expansion strategy following its recent PHP 5.3bn (USD 90m) initial public offering. The report cited comments by CREC President and CEO Oliver Tan at a press briefing after the company’s stock was listed on the Philippine Stock Exchange. The CEO said the issue could potentially be next year, although the company would wait for a rate cut, for interest rates to go down. An offer size was yet to be decided, he said. CREC has a generation capacity of 285 MW. It plans to develop more solar plans targeting completion of 1 GW every year to meet its five-year target, the report stated.",
    InvestableRating: 89,
    EstimatedProjectCost: "NA",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: DevelopmentWaste,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
},
{
    key: "106",
    title: "Green Li-ion Pte Ltd",
    Location: "Singapore",
    City: "",
    categories: [
        {
            name: "Energy",
            subcategories: ["Other"]
        }
    ],
    description: "Green Li-ion, a lithium-ion battery recycling technology provider, is raising a minority equity round to fund growth, according to two sources familiar with the situation. Nomura has been appointed to assist with the capital raise, the sources said. Singapore-headquartered Green Li-ion is targeting to raise around USD 150m from the equity round, according to the first source. The proceeds will be used to fund expansion for its licensing and tolling business lines, the same source said. In April, the company launched its first commercial-scale facility to process unsorted lithium-ion battery waste and produce cathode precursor, lithium, and anode materials. The facility, installed in an existing recycling plant in Oklahoma, USA, is expected to create two metric tonnes of battery-grade precursor cathode active materials, with plans to quadruple this capacity within the coming year. Green Li-ion installs its plants in customer facilities through licensing agreements. It also offers manufacturers and recyclers the option to send their used lithium-ion battery “black mass” to Green Li-ion-owned plants for direct processing through tolling agreements. Established in 2020 by founders CEO Leon Farrant and CTO Reza Katal, the company has secured more than USD 36.9m in funding from backers including Equinor Ventures, SOSV, EDP, Banpu NEXT, TES, Energy Revolution Ventures, TRIREC, and Petronas. Green Li-ion provides its modular hardware units for original equipment manufacturers, diversified industrials with battery recycling arms, and pure-play recycling companies. Green Li-ion has over 40 staff across five offices in Singapore, South Korea, Australia, the US, and Germany, according to its website.",
    InvestableRating: 88,
    EstimatedProjectCost: "USD 100m-500m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: GreaterCirebonMetropolitanArea,
    map: "Singapore",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
},
{
    key: "107",
    title: "Kaer",
    Location: "Singapore",
    City: "",
    categories: [
        {
            name: "Energy",
            subcategories: ["Other"]
        }
    ],
    description: "Kaer, a Singapore-headquartered cooling equipment services provider, is seeking to raise fresh capital via an equity sale to fund growth, according to two sources familiar with the matter. BDA Partners is advising this maiden growth capital raise, the sources said. The company aims to raise between USD 50m to USD 100m and close a deal by 2H24. Last year, it earned an EBITDA of about USD 10m, the first source said. Information memoranda were distributed late last year and the sell-side started to collect non-binding bids in late April. Strategics and infrastructure funds, attracted by Kaer’s long-term commercial and industrial (C&I) contracts, would be drawn to this process, the first source said. Kaer’s revenue, mostly derived from its Singapore operations, was in the low teens in USD millions during fiscal year 2023 ending December. The company operates around 30 projects in Singapore, Malaysia, Indonesia, and India, according to the first source. Founded in 1993, Kaer operates a ‘Cooling as a Service’ (CaaS) business and bills its customers on a pay-as-you-use model. The usual tenure of a CaaS agreement is 15 years. It provides chiller plants and air-side equipment to shopping and data centres, pharmaceuticals and manufacturing production facilities, as well as to education campuses. KKR-backed Barghest Building Performance is another Singapore-headquartered energy efficiency company, providing energy-saving technology for heating and cooling systems for commercial and industrial buildings.",
    InvestableRating: 86,
    EstimatedProjectCost: "USD 50m-100m",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: JointDevelopmentofHydropower,
    map: "Singapore",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
    },
    source: "In Market",
    concessionPeriod: "Not Disclosed"
},
{
    key: "108",
    title: "SkyX minority equity sale",
    Location: "Vietnam",
    City: "",
    categories: [
        {
            name: "Energy",
            subcategories: ["Solar"]
        }
    ],
    description: "EDF Renewables-owned Vietnamese rooftop solar developer SkyX Solar is in the market to raise up to USD 25m through a minority equity sale, three sources familiar told Infralogic. SkyX, a joint venture between French utility EDF and Vietnam's VinaCapital, has appointed Finergreen to advise on the capital raise, sources said. The money will be used for the developer's growth. SkyX declined to comment for the article while EDF, Finergreen and VinaCapital did not respond to requests for comment. The solar developer owns more than 100 MW of solar projects in operation or development across Vietnam. Set up by founder Samresh Kumar who is also the Chairman and CEO, SkyX provides rooftop solar and other distributed energy solutions for commercial and industrial (C&I) customers in the Southeast Asian nation. The company was backed by VinaCapital at the time of its launch in 2019. Currently, EDF owns a majority equity stake in SkyX, according to one of the sources. In October 2021, EDF Renewables made an investment in SkyX Energy, the holding company of SkyX Solar. It did not disclose the size of the investment at the time but said that it was 'significant' and added that it is keen to expand in Vietnam. SkyX had 30 MW of operating solar projects at the time and planned to invest more than USD 100m to develop another 200 MW of projects over the next few years. Vietnam’s rooftop solar sector has grown in recent years with cumulative rooftop solar capacity totalling 9.3 GW at the end of 2020. Among the recent deals in the Vietnamese solar rooftop sector, last year Singaporean utility SP Group partnered with CJ OliveNetworks to jointly invest, build, and develop up to 50 MW of rooftop solar projects in Vietnam. In 2021, SP Group also acquired a 49% stake in Vietnamese renewable energy firm BCG Energy's rooftop solar unit Skylar. This March, British International Investment invested USD 18m in Skye Renewables Energy, a C&I solar developer focused on markets such as Vietnam. The UK development finance institution made the investment alongside Japanese energy firm and existing investor Idemitsu Kosan. In 2022, Thai power developer Banpu's renewables unit acquired a 49.04% stake in Vietnamese rooftop solar developer Solar Esco. Further, Actis-backed Levanta Renewables is seeking to grow its renewables capacity in Southeast Asia, with a focus on segments such as rooftop solar in Vietnam, Infralogic reported in March.",
    InvestableRating: 85,
    EstimatedProjectCost: "25",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 3,
    image: LabuanBajoAirport,
    map: "Vietnam",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
},
{
    key: "109",
    title: "Enex Energy Corp",
    Location: "Philippines",
    City: "",
    categories: [
        {
            name: "Energy",
            subcategories: ["Hydro"]
        }
    ],
    description: "Enex Energy Corp, owned by Philippine conglomerate Ayala, is seeking investments in two energy projects, the Manila Standard reported yesterday. The report cited Chairperson Eric Francia as saying the company is looking for partners for Service Contract 55 in the West Philippine Sea and its 1.1 GW combined-cycle gas turbine power plant in Batangas province. Enex Energy's subsidiary, Palawan55 Exploration and Production Corp. (Palawan55) holds a majority of SC 55 in southwest Palawan, which holds the Cinco prospect. Enex is also 'entertaining' potential equity investors for the Batangas gas turbine project, Francia said.",
    InvestableRating: 87,
    EstimatedProjectCost: "NA",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 2,
    image: LegokNangkaRegionalWasteProcessing,
    map: "Philippines",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
},
{
    key: "110",
    title: "SUSI Asia Energy Transition Fund (Energy platform)",
    Location: "Vietnam",
    City: "",
    categories: [
        {
            name: "Energy",
            subcategories: ["Wind", "Solar"]
        }
    ],
    description: "Swiss-based SUSI Partners has reopened its Asia-dedicated fund to raise additional limited partner (LP) commitments to establish a Southeast Asia-focused utility-scale renewables platform, a senior official told Infralogic. The new platform has a target to develop a 300 MW portfolio of greenfield onshore wind and solar PV from up to six construction-ready projects, focusing on the Philippines and Vietnam, said Wymen Chan, SUSI Partners’ Asia Head. Established under the SUSI Asia Energy Transition Fund (SAETF), the platform aims to raise at least USD 100m from the additional fundraise, as well as LP direct and co-investments, he said. The final size could reach USD 150m-USD 180m, depending on investor appetite. The platform will invest equity in wholly-owned renewables projects, which it aims to bring to operational stages within two years, being the SAETF’s remaining investment period, said Chan. The move comes as the fund manager announced an investment in Singapore-headquartered Alba Renewables earlier this week. The deal marked the SAETF’s sixth investment, at which point the fund’s existing capital became fully committed, Chan added. Launched in late 2019, Southeast Asia-focused SAETF held a final close at USD 120m in June 2023. LPs included development finance institutions AIIB, FMO, Norfund, Swedfund, OeEB, BII, and BIO. While SUSI has not set a fundraising target for the fund reopening, the original USD 300m hard cap will remain in place, said Chan. A final close is targeted for September this year, following an expected first close in June with around USD 30m in commitments. The renewable platform’s set up will coincide with the June first closing. “We are already executing on a number of transactions in preparation,” he said. The manager has so far received indicative commitments from existing LPs for the additional raise, and is kicking off talks with prospective investors now, said Chan. It is not working with a placement agent for the reopening. The fund reopening is being done without any changes to the original fund documents, so there are no extensions to the investment period or fund life, said Chan. Successor Asia fund SAETF’s new renewables platform will mark the last fund deployment. “We are already thinking about a broader mandate for a successor fund in Asia which will remain firmly focused on the energy transition but may include more asset classes like growth equity as well as other geographies in Asia,” said Chan. SAETF’s other investments are in: Entoria Sustainable Power Assets, a JV with Singapore’s Entoria Energy to deliver commercial and industrial (C&I) rooftop solar PV Asia Clean Capital Vietnam, a Vietnam-based C&I solar PV developer a partnership with BayWa r.e to develop C&I rooftop PV projects in Southeast Asia Sustainable Energy Solutions Partnership (SEA), a joint venture (JV) with Malaysia’s Invest Energy to finance and operate energy efficiency projects Sustainable Pacific Impact Renewable Energy, a JV with Singapore’s Pacific Impact Development for greenfield solar PV, wind, and hydro development The vehicle targets spending USD 20m-USD 30m in equity per platform.",
    InvestableRating: 94,
    EstimatedProjectCost: "NA",
    TechInvolved: "",
    ProjectStage: "Capital Raising",
    SupportLink: "",
    ESGRating: 4,
    image: MRT11Project,
    map: "Vietnam",
    contactName: "Not Disclosed",
    contactEmail: "Not Disclosed",
    financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
    },
    source: "Inframation - news",
    concessionPeriod: "Not Disclosed"
},
    {
      key: "111",
      title: "Power Sector Assets and Liabilities Management Corp (PSALM)",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Hydro"]
        }
      ],
      description: "Power Sector Assets and Liabilities Management Corp (PSALM), a state-run Philippine company, is expected to raise up to PHP 100bn (USD 1.8bn) from the auction of the 797.92-megawatt Caliraya-Botocan-Kalayaan (CBK) hydropower plants, reported the Philippine Star on 25 March. The report cited Ralph Recto, the Philippine Finance Secretary, who said that the auction could raise between PHP 50bn to PHP 100bn. He added that the auction is anticipated to occur in the coming months.",
      InvestableRating: "80",
      EstimatedProjectCost: "NA",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "3",
      image: BuildSeven,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "Inframation - news",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "112",
      title: "BCG Energy JSC",
      Location: "Vietnam",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Wind","Solar"]
        }
      ],
      description: "Vietnam-based conglomerate Bamboo Capital Group JSC [HOSE:BCG] is once again delaying the initial public offering (IPO) of its renewable energy (RE) subsidiary BCG Energy and is weighing alternative funding options, Vice Chairman Pham Minh Tuan said. The listing of BCG Energy, originally slated before end-2023, was delayed again due to unfavorable market conditions, Pham said. It is, however, still working on its IPO application, which is expected to be completed in 3Q24. As previously reported by this news service, Sacombank Securities JSC (SBS) was tapped to advise on the listing. The vice chairman said the size of the IPO is still to be determined given that there ”had been a lot of changes within the company” since the initial plan to list BCG Energy. According to data released by Deloitte in November last year, there were only three IPOs launched in the first 10.5 months of 2023, which raised a total of about USD 7m. The firm attributed the low number of maiden public offerings to the tightened approval processes by regulators and higher net withdrawal from foreign investors due to global and local factors affecting market liquidity last year. Given that BCG Energy requires VND 35trn (USD 1.42bn) to implement wind and waste-to-energy (WTE) projects in the next two years, it is now exploring alternative fundraising options including bond issuance and seeking project joint venture partners, Pham added. Of the total amount, around VND 20trn is earmarked for wind power plants and the remainder is for WTE projects. BCG Energy is looking to acquire additional WTE projects already with licenses that the company can develop and operate, the vice chairman noted. BCG Energy is acquiring a 90% stake in the Ho Chi Minh City-based waste treatment firm Tam Sinh Nghia Investment Development JSC to enter the WTE segment, Pham said. After the acquisition, BCG Energy will build two waste-to-power plants in Ho Chi Minh City and the neighbouring Long An province. It plans to complete the 40-megawatt (MW) Ho Chi Minh City plant in 2025 for an estimated cost of VND 5trn. It also expects to deploy the other two projects in central Da Nang City and the southern Kien Giang province, as disclosed by the company. Meanwhile, BCG’s talks with a foreign strategic investor for BCG Energy have reached an advanced stage. In August last year, Mergermarket reported that the parent firm was talking to three potential investors and that the private placement would be executed ahead of the IPO. Pham said BCG has yet to find the right fit. In 4Q23, BCG Energy increased its chartered capital from VND 4.5trn to VND 7.3trn via private placement to local investors to help restructure its debts. This chartered capital hike aims to bring down interest payments and give it flexibility in raising additional capital. Following the private placement, BCG’s stake in its energy unit decreased from 82.18% in 3Q23 to 50.66% by the end of last year, as announced. BCG generated total net revenue of VND 4.1trn and net profit of VND 188bn in 2023, down 11.5% and 65% YoY, as disclosed. BCG Energy last year booked net revenue of VND 1.13trn, up 6% YoY but registered a loss of VND 227bn on the back of a deficit in the exchange rate.",
      InvestableRating: "90",
      EstimatedProjectCost: "USD 100m-500m,USD 50m-100m,USD 10m-50m",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "4",
      image: BuildEight,
      map: "Vietnam",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "In Market",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "113",
      title: "Enercon Asia",
      Location: "Singapore",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Solar"]
        }
      ],
      description: "Enercon Asia, a Singapore-based power solutions provider and renewable energy firm, is receptive to fresh approaches from financial and strategic investors who could help finance its expansion in Southeast Asia, Chief Executive Officer Roland Lim said. The company has started discussions with potential institutional investors. The stake size available for sale is still up for discussion since this will depend on what kind of investor it will take, Lim said. Aside from providing financial support, the investor must share the same goals and values as Enercon Asia and has a genuine desire to do its part for community and climate, the CEO said. Having investors on board would accelerate the company’s growth instead of just relying on internal funding alone. It is crucial for companies to form alliances to address global climate issues, he noted. A provider of power control solutions in the past 10 years, Enercon Asia is also receptive to partnerships, including joint ventures, with top-tier power companies and other service providers such as solar panel installers for its Philippine expansion. It plans to develop solar farms in the Philippines and venture into solar rooftop business, Lim said. According to a media report early this month, Enercon Asia plans to invest USD 40m up to USD 100m to develop projects that would produce 50 megawatts of solar energy in the Philippines. Enercon Asia prefers to develop greenfield projects, but it is not ruling out potential investments in brownfield facilities, he added. The CEO pointed out that the company is encouraged to invest in solar projects in the Philippines because of the strong demand for renewables in the country. In addition, the Philippine Department of Energy has released a renewable energy roadmap that will encourage more investments in the sector. Apart from the Philippines, Enercon Asia is also developing a solar project in partnership with the government of Uzbekistan. The company is prepared to expand into new markets in Asia, depending on the type of opportunities presented to the company, Lim said, without identifying specific markets. Enercon Asia, which was formerly called Enercon Systems International, was founded in 1994 as the Asian unit of Illinois-based Enercon Engineering, which designs, manufactures and supplies controls, switchgear, packaging, enclosures, power modules and co-generation units. The company caters to diverse industries, including data centers, telecommunications, hospitals, airports, commercial buildings, manufacturing factories, and smart city projects. The company is not related to Germany-based Enercon, a manufacturer of wind turbines, Lim said.",
      InvestableRating: "70",
      EstimatedProjectCost: "NA",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "3",
      image: BuildNine,
      map: "Singapore",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "Inframation - news",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "114",
      title: "Yinson Production Offshore Pte Ltd",
      Location: "Malaysia",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Solar"]
        }
      ],
      description: "Yinson Holdings [KLSE: YINSON] of Malaysia has engaged an adviser for an approximately USD 1bn fundraising for its Yinson Production Offshore floating production, storage and offloading (FPSO) arm, according to sources cited in a newswire report. The individuals privy to the situation said the funding round is scheduled for official launch as soon as March and will be the precursor to a stock market flotation for the subsidiary, Bloomberg reported. Private equity investors and global funds may be drawn to invest, the sources said. RRJ Capital, a previous Yinson asset investor, is planning to invest USD 320m in the new fundraising, although terms have yet to be finalised, according to RRJ Chief Executive Richard Ong, the report said. A New York-based IPO is under consideration and could take place as early as 2026, although plans could change, sources cited in the piece cautioned. The FPSO operation generated an estimated EBITDA of approximately USD 680m last year, the sources said. A Yinson Holdings official declined to make any comment, the item reported.",
      InvestableRating: "85",
      EstimatedProjectCost: "NA",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "2",
      image: BuildTen,
      map: "Malaysia",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "Inframation - news",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "115",
      title: "Alternergy Holdings",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Wind","Hydro","Solar"]
        }
      ],
      description: "The deal involves Alternergy Holdings, Philippines-based renewable energy company seeking to sell shares to strategic investors, including sovereign wealth funds. Alternergy has been raising funds to finance its renewable project pipeline.",
      InvestableRating: "90",
      EstimatedProjectCost: "NA",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "3",
      image: BuildEleven,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "Inframation - transactions",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "116",
      title: "Synergy Efficiency Solutions",
      Location: "Indonesia",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Other"]
        }
      ],
      description: "Indonesia-based Synergy Efficiency Solutions, a company that helps businesses become more energy efficient, plans to raise up to USD 10m by June 2024 to grow its reach and expand its client base, its Founder and Chief Executive Officer Steve Piro said. Synergy welcomes pitches from advisors that can help it reach out to potential investors. It would prefer blue-chip local investors, such as investment firm Saratoga Investama Sedaya [IDX:SRTG], or one of the venture capital firms founded by Pandu Sjahrir, a prominent Indonesian investor who is focused on energy transition and digitalization of the economy. Synergy will also be receptive to approaches from Mitsui & Co, a Japanese group that operates across chemicals, minerals, and metals in Indonesia, added Piro. The hope is that investments from such firms will help Synergy widen its pool of potential clients. Synergy hasn’t started conversations with any of these investors yet. The fresh funds will allow Synergy to take up more and larger energy efficiency contracts, primarily in Indonesia. It wants to make an annual investment of USD 10m in energy-saving projects over the next five years, said Piro, adding that he expects Synergy to have signed a total of around USD 25m of contracts by June 2024. Synergy’s contracts are under the so-called Energy Efficiency as a Service (ESCO) scheme, whereby the company provides its clients with energy solutions, including designs and implementation of energy-saving projects, without the need for any upfront capital expenditure from the client. Synergy buys all the devices and hands them over to clients after seven years, relieving its clients from upfront investment, the CEO said. Piro, a US citizen, established Synergy in 2008 to assist malls, hotels, hospitals, and universities in Indonesia to become more energy efficient, lower their energy consumption, and in turn lower their energy bills. The company is now also targeting industrial clients. Since its founding, Synergy has completed around 210 energy efficiency projects, mostly locally. The company has also worked on projects in Malaysia, Singapore, the US and Latvia, added Piro. It has helped clients save around USD 16m on their energy bills since 2018, Piro said. The company sealed its first equity fundraising in late 2021 from New Energy Nexus, a clean energy-focused investor, and the Southeast Asia Clean Energy Facility (Seacef). They took a combined stake of around 20%, Piro added, but didn’t disclose the size of the round. Piro owns most of the remaining shares in Synergy. He declined to disclose how much of the company he intends to sell in the new funding round. Further down the road, Synergy will be receptive to acquisition approaches from global energy majors such as France-based utility company Engie SA, he added. Piro sees large, untapped potential for ESCOs in Indonesia as the government has been taking steps to drive energy saving, in addition to its emphasis on transition, sustainable and green energies. The ESCO business model is still largely unheard of in Indonesia, said Piro. Indonesia is the largest energy producer and consumer in Southeast Asia, with the government projecting energy demand to increase by 75% between 2021 and 2040, according to local media. The government requires all companies with energy consumption exceeding 6,000 tons of oil equivalent annually to develop an energy conservation plan, conduct an energy audit and report their energy consumption, local media reported.",
      InvestableRating: "80",
      EstimatedProjectCost: "USD 10m-50m",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "2",
      image: ConnectedBuilding,
      map: "Indonesia",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "In Market",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "117",
      title: "Medco Power Indonesia (MedcoEnergi Power)",
      Location: "Indonesia",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Wind","Solar","Hydro"]
        }
      ],
      description: "Medco Power Indonesia (MedcoEnergi Power), an Indonesia-based independent power provider and a subsidiary of Medco Energi Internasional Tbk, welcomes approaches from strategic investors that can support its undertaking to develop more renewable energy projects in the country, CEO Eka Satria said. The company is open to potential investors that will not only finance such ventures; they must also possess the “knowhow” in renewable energy, Satria told Infralogic's sister publication Mergermarket on the sidelines of The Indonesia New, Renewable Energy Conservation (EBTKE) Conference and Exhibition in Tangerang, West Java on 13 July. It aims to align its business strategy with the Indonesian government’s efforts to achieve net zero carbon by 2060, as per its annual report. Indonesia wants its new and renewable energy to comprise 23% of the primary energy mix by 2025 and 31% by 2050, according to an article by international policy forum EastAsiaForum. The government in September 2022 passed Presidential Regulation No. 112 of 2022 regarding the acceleration of the development of renewable energy for the supply of electrical power (PR 112/2022) in September 2022. Part of the regulation mandates state-owned electric power distributor PT Perusahaan Listrik Negara (PLN) to prioritise the purchase of electricity from renewable power plants, utilize domestic products, and develop renewable power plants, according to an analysis by PwC Indonesia. The country wants to increase investment in the renewable energy sector with the passage of such regulation. In a related development, PLN recently sought bids to co-develop geothermal projects in several locations in the country, it announced. When asked, Satria said they are interested in these geothermal projects that are being offered under PLN’s scheme called Geothermal Exploration and Energy Conservation Agreement (GEECA). As announced, PLN said participants may form a consortium to bid for these projects with a total of 60 megawatts (MW) projected power generation capacity in North and Central Maluku, East Nusa Tenggara, and West Java. MedcoEnergi Power has formed a couple of partnerships for its renewable energy push in recent years. In October 2021, the company entered into an agreement to form a consortium with Singapore-based Gallant Venture and Pacificlight Power to develop, manage, finance, build, engineer, procure, construct, commission, operate, and maintain a Solar PV plant at Pulau Bulan and connect to the Singapore Power Grid network at Pacificlight’s existing site on Jurong Island to supply renewable energy to Singapore. In the previous year, it signed an agreement with Japan’s Kansai Electric to form a joint venture in Indonesia to build and manage gas-powered electricity plants in the country. Meanwhile, the company has been conducting studies on several clean and renewable energy developments. Among these include a grant it received from the US Trade Development Agency in May this year to conduct a feasibility study for a 111 MW wind power plant in West Sumbawa, West Nusa Tenggara, it announced. It has also conducted research with Sembcorp on the potential of green hydrogen, while its collaboration with Kansai Electric Power centers around the decarbonization of steam power plants in Central and East Java. The company owns and operates hydro-power, geothermal, gas, and combined cycle power plants across 15 locations in Indonesia, delivering a 3,100 MW capacity of clean and renewable power, as per its report. For 2022, it has sold 3,393 GWh of electricity, up 24.83% from 2,718 GWh in 2021. Its EBITDA was IDR 686bn (USD 45.7m) in the same period. In the same year, the company made a profit of IDR 67.5bn on a revenue of IDR 1.74trn, from IDR 396.6bn on revenue of IDR 1.8trn in the previous year.",
      InvestableRating: "75",
      EstimatedProjectCost: "NA",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "4",
      image: NewBoholInternationalAirportProject,
      map: "Indonesia",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "Inframation - news",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "118",
      title: "Xurya Daya Indonesia",
      Location: "Indonesia",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Solar"],
        },
      ],
      description: "Xurya Daya Indonesia, an Indonesian rooftop solar power plant developer startup, is planning a new fundraising round by the close of 2023, reported DealStreetAsia today (24 June). The report cited Eka Himawan, the co-founder of the company, who said that this round will be larger than the group’s previous one. The funds will go toward supporting new projects. In 2021 and 2022, the company raised USD 33m as part of a Series A round of fundraising which was backed by Muitsui & Co, Surya Semesta Internusa [IDX: SSIA], Tokopedia, Endeavor Indonesia, Crevisse, New Energy Nexus, Schneider Electric and Saratoga Investama Sedaya.",
      InvestableRating: "90",
      EstimatedProjectCost: "USD 50m-100m,USD 10m-50m",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "3",
      image: OneRafflesPlaceSmartTechAdoption,
      map: "Indonesia",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "In Market",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "119",
      title: "Athein Holding",
      Location: "Singapore",
      City: "",
      categories: [
        {
          name: "Energy",
          subcategories: ["Solar"],
        },
      ],
      description: "Athein, a Singapore-based joint venture platform company between ATAD Steel Structure Corporation, Hexagon Holdings, Inpos and Invenic Inc, has hired Green Horizon Capital Partners as an advisor for an equity raising, according to a newswire report today (12 June). The report cited the CEO of Athein, Milan Koev, who said that the company is seeking to raise between USD 250m-USD 300m in equity. The funds will go toward planned wind and solar projects in Vietnam, the Philippines and India. In total, the company will seek to raise USD 1bn over the coming five years. Besides the equity portion, the company will raise the remaining amount from debt. Green Horizon has already begun gauging the interest of strategic investors, PE funds and infrastructure funds.",
      InvestableRating: "75",
      EstimatedProjectCost: "> USD 500m,USD 100m-500m",
      TechInvolved: "",
      ProjectStage: "Capital Raising",
      SupportLink: "",
      ESGRating: "3",
      image: PhnomPenhCitySolidWasteCollection,
      map: "Singapore",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "In Market",
      concessionPeriod: "Not Disclosed"
    },
    // {
    //   key: "120",
    //   title: "Gentari Potenial Equity Injection",
    //   Location: "Malaysia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Energy",
    //       subcategories: ["Wind", "Solar", "Hydrogen"],
    //     },
    //   ],
    //   description: "Gentari, clean energy arm of Malaysian oil major Petronas, is in talks for a potential equity injection (minority equity financing between 25% - 40% stake):\n• Transaction could fetch more than USD1bn\n• It currently has a 3.6 GW installed and under construction portfolio across wind, solar and energy storage in India, Australia, and Malaysia. In India, it has over 4.93 GW capacity across operational and under construction projects, and has reportedly agreed to buy a 2.2 GW portfolio from Brookfield for USD 900m.\n• Gentari also has ambitions for clean hydrogen, targeting to deliver up to 1.2 million tonnes per annum (mtpa) by 2030. It has agreed to jointly invest in India’s 5mtpa AM Green Ammonia Holdings project, also backed by Greenko and GIC. It has partnerships to explore various hydrogen initiatives, including with Singapore’s Senoko Energy, Malaysia’s SEDC Energy, and Japan’s IHI Corporation.\n• The Kuala Lumpur-headquartered company operates electric vehicle (EV) charging infrastructure, where it is Malaysia’s leading fast charging point operator, according to its website. Its green mobility business, which also provides B2B EV services, spans across India, Indonesia, and Thailand.",
    //   InvestableRating: "70",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: TheBantenWindFarmPowerDevelopment,
    //   map: "Malaysia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: ""
    // },
    // {
    //   key: "121",
    //   title: "Exxon Mobil - sale of its retail gas station in Singapore",
    //   Location: "Singapore",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Energy",
    //       subcategories: ["Natural Gas"],
    //     },
    //   ],
    //   description: "• Annual EBITDA of over USD100m and the seller is seeking a valuation of around USD 1bn",
    //   InvestableRating: "85",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "2",
    //   image: Naturalgas1,
    //   map: "Singapore",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "122",
    //   title: "Chevron refinery assets in Singapore – Singapore Refining Company is being evaluated for a potential exit",
    //   Location: "Singapore",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Energy",
    //       subcategories: ["Natural Gas"],
    //     },
    //   ],
    //   description: "290,000 barrel processing capacity",
    //   InvestableRating: "80",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "4",
    //   image: Naturalgas2,
    //   map: "Singapore",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "123",
    //   title: "ACEN, renewables unit of Philippines conglomerate, Ayala Corp is seeking more than USD500m debt to finance future projects",
    //   Location: "Philippines",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Energy",
    //       subcategories: ["Wind", "Solar"],
    //     },
    //   ],
    //   description: "ACEN has a 6.8 GW portfolio of operational, under-construction and committed renewables projects across the Philippines, Australia, Vietnam, India, Indonesia, Lao PDR and the US. The Philippines accounts for 40% of ACEN’s generational portfolio while its international assets have a net attributable capacity of 2.84 GW",
    //   InvestableRating: "90",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: EnergyFive,
    //   map: "Philippines",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "124",
    //   title: "Thailand PTT Restructuring",
    //   Location: "Thailand",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Energy",
    //       subcategories: ["Wind", "Solar"],
    //     },
    //   ],
    //   description: "Thailand PTT restructuring\n• Merger of certain assets, new equity investment being considered. PTT has picked Bualuang Securities Pcl and UBS Group AG to review the Thai energy group's downstream assets",
    //   InvestableRating: "70",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "2",
    //   image: SidrapWindFarm,
    //   map: "Thailand",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "125",
    //   title: "Metro Pacific looking for Private Equity Investor for Tollroad Projects",
    //   Location: "Indonesia",
    //   City: "",
    //   categories: [
    //     {
    //       name:"Transportation",
    //       subcategories: ["Expressway"],
    //     },
    //   ],
    //   description: "Metro Pacific could seek a private equity investor in the tollways unit to help fund the acquisition of a 35% stake in PT Jasamarga Transjawa Tol (JTT), a subsidiary of Indonesian state-owned toll road company PT Jasa Marga (Persero) Tbk (Jasa Marga).",
    //   InvestableRating: "75",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: ExpressTransport,
    //   map: "Indonesia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "126",
    //   title: "KKR to revisit Bulk Container Provider",
    //   Location: "Singapore",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Transportation",
    //       subcategories: ["Logistics"],
    //     },
    //   ],
    //   description: "KKR plans to revisit a sale of Singapore-based intermediate bulk container provider Goodpack\n• KKR acquired Goodpack for USD 1bn in a May 2014 deal that took the company private from the SGX\nEstablished in 1980, Goodpack is the world’s first and largest provider of reusable pallet-sized intermediate bulk containers on a pay-per-use basis to companies transporting valuable payloads globally by road, rail, or sea",
    //   InvestableRating: "85",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "4",
    //   image: Logistics,
    //   map: "Singapore",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "127",
    //   title: "Princeton Digital Group Fund Raise",
    //   Location: "Singapore, Indonesia, Malaysia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Data Centres"],
    //     },
    //   ],
    //   description: "Princeton Digital Group fund raise\n• The transaction is expected to raise around USD 1bn and may involve an exit by early backer Warburg Pincus should it secure an acceptable price\nPrinceton Digital Group operates more than 1 GW of capacity across 20 data centres in mainland China, Singapore, India, Indonesia, Malaysia, and Japan. It is currently expanding in Singapore, Malaysia’s Johor state, Indonesia’s Batam city, and India while actively exploring new markets South Korea and Australia, according to its website.",
    //   InvestableRating: "75",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: Datacentres1,
    //   map: "Singapore, Indonesia, Malaysia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "128",
    //   title: "Singapore Data Centre Platform Equity Raising",
    //   Location: "Singapore",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Data Centres"],
    //     },
    //   ],
    //   description: "Singapore headquartered data centre platform equity raise (P&C at this stage)",
    //   InvestableRating: "95",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "2",
    //   image: Datacentres2,
    //   map: "Singapore",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "129",
    //   title: "Telkom Neutra DC",
    //   Location: "Indonesia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Data Centres"],
    //     },
    //   ],
    //   description: "Telkom NeutraDC\n• Minority sale\n• NeutraDC currently manages 29 data centers, including five global facilities and three enterprise data centers in the provinces of Bogor Regency, South Tangerang and Surabaya. Additionally, they operate a hyperscale data center in Jakarta and another one in Cikarang city, Bekasi Regency. Two more data centers are under construction on Batam Island, near Singapore",
    //   InvestableRating: "90",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "4",
    //   image: Datacentres1,
    //   map: "Indonesia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "130",
    //   title: "PLDT Data Centres",
    //   Location: "Philippines",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Data Centres"],
    //     },
    //   ],
    //   description: "PLDT DC (process may be advanced on this)\n• Sale of a minority stake in its USD 1bn data centre portfolio\n• PLDT’s data centre portfolio comprises 11 facilities spread over the Mega Manila region.",
    //   InvestableRating: "70",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: Datacentres2,
    //   map: "Philippines",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "131",
    //   title: "KKR to exit Metro Pacific Health",
    //   Location: "Philippines",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Social Infrastructure",
    //       subcategories: ["Hospital"],
    //     },
    //   ],
    //   description: "Metro Pacific Health\n• KKR considering exit\n• Valuation of at least USD 3bn",
    //   InvestableRating: "85",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "2",
    //   image: Hospital1,
    //   map: "Philippines",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "132",
    //   title: "Global School Group",
    //   Location: "Singapore",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Social Infrastructure",
    //       subcategories: ["School"],
    //     },
    //   ],
    //   description: "Global Schools Group\n• Global Schools Group was reported to be exploring options including a potential sale of minority stake following interest from prospective investors.\n• Deal size: SGD1.5b (c.USD1.1b)\n• No. of assets: 13 school brands, 63 campuses across 10 countries",
    //   InvestableRating: "75",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: School1,
    //   map: "Singapore",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "133",
    //   title: "Edge Point Infrastructure",
    //   Location: "Malaysia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Telecommunications"],
    //     },
    //   ],
    //   description: "Malaysia-headquartered tower infrastructure subsidiary EdgePoint Infrastructure\n• Marketed at USD 200m forward EBITDA and targeting a multiple in the low-mid teens\n• DigitalBridge is aiming to fully exit its investment, the sources said it is unclear if fellow shareholder Abu Dhabi Investment Authority (ADIA) also intends to dispose of its entire shareholding\n• EdgePoint owns 10,000 towers in Indonesia via its 92.17% subsidiary Centratama Group, as well as 2,800 tpwers in the Philippines, and 1,500 in Malaysia",
    //   InvestableRating: "70",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "4",
    //   image: Telecommunication2,
    //   map: "Malaysia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "134",
    //   title: "Edotco looking for Potential Deal",
    //   Location: "Malaysia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Telecommunications"],
    //     },
    //   ],
    //   description: "Edotco, a telecoms infrastructure unit of Malaysia's Axiata Group\n• potential deal could value the unit at approximately USD 3.5bn\n• Innovation Network Corp. of Japan (INCJ) seeks to offload its 21% stake in edotco before its operational mandate expires in March 2025",
    //   InvestableRating: "75",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "2",
    //   image: Telecommunication1,
    //   map: "Malaysia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "135",
    //   title: "Majority Sale of PT Indosat Ooredoo",
    //   Location: "Indonesia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Telecommunications"],
    //     },
    //   ],
    //   description: "Majority sale of PT Indosat Ooredoo Hutchison (Indosat) Tbk fibre optic unit\n• The buyer would need to support an existing master lease agreement for Indosat’s fibre backhaul, plus a greenfield rollout of Indosat’s fiber-to the-home (FTTH) network, which has an expected CAPEX of USD 1bn",
    //   InvestableRating: "85",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "3",
    //   image: Telecommunication3,
    //   map: "Indonesia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "136",
    //   title: "PT Link Net Tbk",
    //   Location: "Malaysia, Indonesia",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Telecommunications"],
    //     },
    //   ],
    //   description: "PT Link Net Tbk\n• Axiata Group, the Malaysian telecommunications group, has kicked off the partial sale of its stake in PT Link Net Tbk to fund the Indonesian cable television and broadband service provider’s fiber expansion\n• The seller could raise up to USD 1bn from the potential deal, and a majority stake could be on offer depending on talks with bidders\n• The company is 76.42% owned by Axiata Investments (Indonesia) Sdn Bhd, according to its website. The remaining shares are held by XL Axiata (19.22%), in treasury (3.9%) and by the public (0.46%)",
    //   InvestableRating: "75",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "4",
    //   image: Telecommunication4,
    //   map: "Malaysia, Indonesia",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    // {
    //   key: "137",
    //   title: "Pinnnacle Tower is selling a minority stake to expand operation to Philippines",
    //   Location: "Philippines",
    //   City: "",
    //   categories: [
    //     {
    //       name: "Digital Infrastructure",
    //       subcategories: ["Telecommunications"],
    //     },
    //   ],
    //   description: "Pinnacle Towers is selling a minority stake to expand its operations in the Philippines\n• Selling a stake of between 10% to 25%, which is a mix of primary and secondary shares",
    //   InvestableRating: "75",
    //   EstimatedProjectCost: "Not Disclosed",
    //   TechInvolved: "",
    //   ProjectStage: "Capital Raising",
    //   SupportLink: "",
    //   ESGRating: "2",
    //   image: Telecommunication5,
    //   map: "Philippines",
    //   contactName: "Not Disclosed",
    //   contactEmail: "Not Disclosed",
    //   financialFeasibility: {
    //     irr: "Not Disclosed",
    //     npv: "Not Disclosed"
    //   },
    //   source: "KPMG Intelligence",
    //   concessionPeriod: "Not Disclosed"
    // },
    {
      key: "138",
      title: "MAPALLA Ferry Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Transportation",
          subcategories: ["Ports"],
        },
      ],
      description: "Transaction advisory for a Greenfield ferry project in Philippines",
      InvestableRating: "70",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "3",
      image: AmbonPort,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "139",
      title: "North Long-Haul Inter-Regional Railway Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name:"Transportation",
          subcategories: ["Railways"],
        },
      ],
      description: "Transaction advisory for a Greenfield railway project in Philippines",
      InvestableRating: "85",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "4",
      image: Subway,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: ""
    },
    {
      key: "140",
      title: "Mindanao Railway Phase III Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Transportation",
          subcategories: ["Railways"],
        },
      ],
      description: "Transaction advisory for a Greenfield railway project in Philippines",
      InvestableRating: "90",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "2",
      image: Subway,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "141",
      title: "DOTr Central Office Main Building Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Social Infrastructure",
          subcategories: ["Other"],
        },
      ],
      description: "Transaction advisory for a Greenfield government building project in Philippines",
      InvestableRating: "65",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "3",
      image: BuildEleven,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "142",
      title: "North Integrated System Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Social Infrastructure",
          subcategories: ["Other"],
        },
      ],
      description: "Transaction advisory for a Greenfield urban development project in Philippines",
      InvestableRating: "85",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "4",
      image: BuildOne,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "143",
      title: "San Mateo Railway Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Transportation",
          subcategories: ["Railways"],
        },
      ],
      description: "Transaction advisory for a Greenfield railway project in Philippines",
      InvestableRating: "75",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "2",
      image: Subway,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "144",
      title: "NCR EDSA Busway Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Transportation",
          subcategories: ["Bus"],
        },
      ],
      description: "Transaction advisory for a Greenfield busway project in Philippines",
      InvestableRating: "80",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "3",
      image: BetanBusTerminal,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "145",
      title: "Cebu International Container Port Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Transportation",
          subcategories: ["Ports"],
        },
      ],
      description: "Transaction advisory for acquisition and O&M of a port project in Philippines",
      InvestableRating: "85",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "4",
      image: AmbonPort,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "146",
      title: "Nuclear Medicine Research and Innovation Center Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Social Infrastructure",
          subcategories: ["Other"],
        },
      ],
      description: "Project Preparation Services for a Greenfield healthcare project in Philippines",
      InvestableRating: "95",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "2",
      image: Hospital2,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "147",
      title: "Fiber-Enabled Free Public Internet Access Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Digital Infrastructure",
          subcategories: ["Data Centres"],
        },
      ],
      description: "Project Preparation Services for a Greenfield broadband project in Philippines",
      InvestableRating: "70",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "3",
      image: BuildThree,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "148",
      title: "Underground Fiber Optic Conduit Network Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Digital Infrastructure",
          subcategories: ["Data Centres"],
        },
      ],
      description: "Project Preparation Services for a Greenfield broadband project in Philippines",
      InvestableRating: "75",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "4",
      image: BuildFour,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "149",
      title: "MRT Line 5 Project",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Transportation",
          subcategories: ["Railways"],
        },
      ],
      description: "Transaction advisory for a Greenfield railway project in Philippines",
      InvestableRating: "80",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "2",
      image: Subway,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "150",
      title: "Government Network Access Project - Marinduque",
      Location: "Philippines",
      City: "",
      categories: [
        {
          name: "Digital Infrastructure",
          subcategories: ["Data Centres"],
        },
      ],
      description: "Project Preparation and transaction advisory for a Greenfield broadband project in Philippines",
      InvestableRating: "85",
      EstimatedProjectCost: "Not Disclosed",
      TechInvolved: "",
      ProjectStage: "Early-stage",
      SupportLink: "",
      ESGRating: "3",
      image: BuildFive,
      map: "Philippines",
      contactName: "Not Disclosed",
      contactEmail: "Not Disclosed",
      financialFeasibility: {
        irr: "Not Disclosed",
        npv: "Not Disclosed"
      },
      source: "External Sources",
      concessionPeriod: "Not Disclosed"
    },
    {
      key: "151",
      title: "Ir. H. Djuanda Water Supply (Jatiluhur II)",
      Location: "Indonesia",
      City: "Jakarta",
      categories: [
        {
          name: "Utility",
          subcategories: ["Water"],
        },
      ],
      description:
        "Ir H Djuanda (Jatiluhur II) project aims to improve water access and service to the public through applying the end-to-end method (construction from upstream to customer connections). Ir. H. Djuanda Water Supply has a production capacity of 6,790 lps, with a raw water capacity around 7,000 lps. The project will serve 4 areas, that consist of: DKI Jakarta (2,054 lps), Bekasi City (1,051 lps), Bekasi Regency (1.371 lps), and Bogor Regency (2.012 lps).",
      InvestableRating: "80",
      EstimatedProjectCost: "USD 1,180 Million",
      TechInvolved: "AI and IoT",
      ProjectStage: "Planning",
      SupportLink:
        "https://investinindonesia.uk/wp-content/uploads/2022/08/PPP-Ir-Djuanda-Jatiluhur-II-Water-Supply-System.pdf",
      ESGRating: "4",
      image: utilityOne,
      map: "Indonesia, Jakarta",
      // map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d253840.49131649232!2d106.66470446328029!3d-6.229720928728279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e945e34b9d%3A0x5371bf0fdad786a2!2sJakarta%2C%20Indonesia!5e0!3m2!1sen!2sin!4v1684888991041!5m2!1sen!2sin",
      contactName: "",
      contactEmail: "",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "PPP Infrastructure projects plan in Indonesia 2022",
      concessionPeriod: "30",
    },
    {
      key: "152",
      title: "Timor-Leste: Dili West Water Supply Project",
      Location: "Timor - Leste",
      City: "",
      categories: [
        {
          name: "Utility",
          subcategories: ["Water"],
        },
      ],
      description:
        "The project will deliver new climate-resilient water supply infrastructure to expand and improve the performance of water services. This will be supported by interventions to strengthen the water utility's operational performance and enhance its long-term financial sustainability.",
      InvestableRating: "40",
      EstimatedProjectCost: "USD 127 Million",
      TechInvolved: "",
      ProjectStage: "Planning",
      SupportLink: "https://www.adb.org/projects/54429-001/main",
      ESGRating: "4",
      image: utilityTwo,
      map: "Timor%20-%20Leste",
      contactName: "",
      contactEmail: "",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "ADB",
      concessionPeriod: "",
    },
  
    {
      key: "153",
      title: "Sinumbra Regional Water Supply System",
      Location: "Indonesia",
      City: "West Java",
      categories: [
        {
          name: "Utility",
          subcategories: ["Water"],
        },
      ],
      description:
        "The project will deliver new climate-resilient water supply infrastructure to expand and improve the performance of water services. This will be supported by interventions to strengthen the water utility's operational performance and enhance its long-term financial sustainability.",
      InvestableRating: "30",
      EstimatedProjectCost: "USD 51.25 Million",
      TechInvolved: "",
      ProjectStage: "Procurement",
      SupportLink:
        "https://investinindonesia.uk/wp-content/uploads/2022/08/PPP-Sinumbra-Water-Supply-System.pdf",
      ESGRating: "5",
      image: VietnamWaterSupplyInfrastructure,
      map: "Indonesia,West%20Java",
      contactName: "Drs. Wahyu Mijaya SH. M.Si",
      contactEmail: "airminum.disperkim@jabarprov.go.id",
      financialFeasibility: {
        irr: "12.56%",
        npv: "22.3",
      },
      source: "",
      concessionPeriod: "20",
    },
    {
      key: "154",
      title: "Binh Duong Water Treatment Expansion Project",
      Location: "Vietnam",
      City: "Binh Duong, Tinh Binh Duong",
      categories: [
        {
          name: "Utility",
          subcategories: ["Water"],
        },
      ],
      description:
        "The Project involves the expansion by 100 million liters per day (MLD) water production capacity in the Tan Hiep Water Treatment Plant, Viet Nam. This capacity will serve domestic consumption and industrial zones in Ben Cat Town, Tan Uyen Town and Thu Dau Mot City. The expansion includes additional water intake pumps and 9 km of raw water transmission pipes from the Dong Nai River and the downstream distribution network. The total project cost will be $[46] million, of which the upstream water intake work and raw water transmission, downstream distribution network connection and project preparation would cost $[30] million and the additional water production capacity and works within the Tan Hiep Water Treatment Plan would be $16 million.",
      InvestableRating: "50",
      EstimatedProjectCost: "USD 46 Million",
      TechInvolved: "",
      ProjectStage: "Planning",
      SupportLink: "https://www.adb.org/projects/54074-001/main",
      ESGRating: "4",
      image: utilityFive,
      map: "Vietnam, Binh%20Duong",
      contactName: "",
      contactEmail: "",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "ADB",
      concessionPeriod: "",
    },
    {
      key: "155",
      title:
        "Greater Cirebon Metropolitan Area (Jatigede) Regional Water Supply Project Phase I",
      Location: "Indonesia",
      City: "West Java",
      categories: [
        {
          name: "Utility",
          subcategories: ["Water"],
        },
      ],
      description:
        "Jatigede regional water supply system is planned to serve the Greater Cirebon Area. The system is designed with a capacity of 1500 lps which will flow through 5 municipalities. Business Enterprise assists the investment, construction and operation of the production and transmission system to the Reservoir at 7 off-take locations. The business enterprise is expected to assist investment, development and project management. The return on investment is obtained from the sale of bulk water to PDAMs in 5 cities",
      InvestableRating: "60",
      EstimatedProjectCost: "USD 142 Million",
      TechInvolved: "",
      ProjectStage: "Planning",
      SupportLink:
        "http://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
      ESGRating: "4",
      image: GreaterCirebonMetropolitanArea,
      map: "Indonesia, West Java",
      contactName: "Mohammad Taufiq Budi Santoso",
      contactEmail: "simpulkpbujabar@gmail.com",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
      concessionPeriod: "",
    },
    {
      key: "156",
      title: "Ciayumajakuning waste to energy project",
      Location: "Indonesia",
      City: "Cirebon",
      categories: [
        {
          name: "Energy",
          subcategories: ["Waste to Energy"],
        },
      ],
      description:
        "The Ciayumajakuning Waste to Energy Project is designed to cover Greater Cirebon area. This project will managed solid waste generate from 5 municipalities. Around the services area, there are 10 new cities will be developed known as the Rebana Golden Triangle. Recognizing population growth, urban development and estimated waste production, WTE will be built under the PPP scheme.",
      InvestableRating: "30",
      EstimatedProjectCost: "USD 33 Million",
      TechInvolved: "",
      ProjectStage: "Planning",
      SupportLink:
        "http://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
      ESGRating: "4",
      image: SemarangWastetoEnergyProject,
      map: "Indonesia,Cirebon",
      contactName: "Mohammad Taufiq Budi Santoso",
      contactEmail: "simpulkpbujabar@gmail.com",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
      concessionPeriod: "",
    },
    {
      key: "157",
      title: "Metropolitan Bandung urban railway system development",
      Location: "IndonesiaCirebon",
      City: "Bandung",
      categories: [
        {
          name: "Built Environment",
          subcategories: ["Railways"],
        },
      ],
      description:
        "Changi international airport’s new passenger Terminal 5 (T5) in Singapore will have an annual passenger capacity of 50 million.",
      InvestableRating: "40",
      EstimatedProjectCost: "USD 310 Million",
      TechInvolved: "",
      ProjectStage: "Planning",
      SupportLink:
        "http://kpbu.jabarprov.go.id/public_storage/uploads/2019/11/bappeda_jabar_iidf_jakarta_6_nov_2019_22.00_061119105157.pdf",
      ESGRating: "3",
      image: MRT11Project,
      map: "Indonesia,Bandung",
      contactName: "Mohammad Taufiq Budi Santoso",
      contactEmail: "simpulkpbujabar@gmail.com",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "Accelerating West Java Infrastructure Development Through Creative Financing Scheme",
      concessionPeriod: "",
    },
    {
      key: "158",
      title: "Bislig City Bulk Water Supply and Septage Project",
      Location: "Philippine",
      City: "Bislig City",
      categories: [
        {
          name: "Utility",
          subcategories: ["Water"],
        },
      ],
      description:
        "The Bislig City Bulk Water Supply and Septage Project is envisioned to mitigate the risks and impact of climate change by ensuring the reliability and sustainability of water supply and access to potable water and ensure proper septage management in the City. BCWD intends to develop this Project through public-private partnership. ",
      InvestableRating: "50",
      EstimatedProjectCost: "USD 5.8 Million",
      TechInvolved: "",
      ProjectStage: "Planning",
      SupportLink:
        "https://ppp.gov.ph/ppp_projects/bislig-city-bulk-water-supply-and-septage-project/#:~:text=The%20Bislig%20City%20Bulk%20Water,septage%20management%20in%20the%20City.",
      ESGRating: "5",
      image: BisligCityBulkWaterSupplyandSeptage,
      map: "Philippine,Bislig%20City",
      contactName: "Engr. Menillo C. Siega",
      contactEmail: "mscord@yahoo.com",
      financialFeasibility: {
        irr: "",
        npv: "",
      },
      source: "Republic of the Philippines Public-Private Partnership Center",
      concessionPeriod: "",
    },
  
];
